(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3909"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3909"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6VdLB", function(module, exports) {

$parcel$export(module.exports, "getMotionEnabled", function () { return $50a2bec4c503032f$export$3d370ede101d15fd; });
const $50a2bec4c503032f$export$3d370ede101d15fd = ()=>{
    const prefersReducedMotion = typeof window.matchMedia === "function" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const motionEnabled = document.documentElement.classList.contains("motion-safe") || !prefersReducedMotion;
    document.documentElement.classList.toggle("motion-safe", motionEnabled);
    return motionEnabled;
};

});


/**
 * Shared contact tracking for HIMML Bestattungen and HIMML Vorsorge.
 * Imported by src/bundle.js and compiled with the theme by Parcel.
 */ (()=>{
    "use strict";
    if (window.himmlContactTrackingLoaded) return;
    window.himmlContactTrackingLoaded = true;
    // Add new HIMML numbers here in international format, in both theme copies.
    const ownPhoneNumbers = new Set([
        "+4992165559",
        "+499217577144",
        "+499277975581",
        "+4992736277",
        "+499203306",
        "+49921530404611",
        "+4992153040411",
        "+4915114845022",
        "+4915114845027",
        "+49921530404612",
        "+4992153040412",
        "+49921530404614",
        "+4992153040414",
        "+49921530404615",
        "+4992153040415",
        "+4915114845026",
        "+491704749895",
        "+49921530404623",
        "+4992153040423",
        "+49921530404620",
        "+4992153040420",
        "+4915114845028"
    ]);
    const ownEmailDomains = new Set([
        "himml-bestattungen.de",
        "himml-vorsorge.de"
    ]);
    const serviceNumbers = new Set([
        "110",
        "112",
        "116117"
    ]);
    const legacyContactClass = /^plausible-event-name(?:=|--)(?:phoneclick|emailclick|externalcontactclick)$/i;
    function decode(value) {
        try {
            return decodeURIComponent(value);
        } catch  {
            return value;
        }
    }
    function normalizePhone(value) {
        let number = decode(value.split(/[;?#]/)[0]).replace(/[^\d+]/g, "");
        if (number.startsWith("00")) number = "+" + number.slice(2);
        else if (number.startsWith("0")) number = "+49" + number.slice(1);
        return number.replace(/^\+490/, "+49");
    }
    function decodeEmail(value) {
        return value.replace(/\[at\]/gi, "@").replace(/[a-z]/gi, (character)=>{
            const start = character <= "Z" ? 65 : 97;
            return String.fromCharCode((character.charCodeAt(0) - start + 13) % 26 + start);
        });
    }
    function getContact(link) {
        const href = (link.getAttribute("href") || "").trim();
        if (/^tel:/i.test(href)) {
            const number = normalizePhone(href.slice(4));
            if (!number) return null;
            return {
                type: "phone",
                own: ownPhoneNumbers.has(number),
                ignored: serviceNumbers.has(number.replace(/^\+49/, ""))
            };
        }
        const encodedEmail = link.getAttribute("data-enc-email");
        let email;
        if (/^mailto:/i.test(href)) // Never include subject, message body or other mailto parameters in analytics.
        email = decode(href.slice(7).split("?")[0]);
        else if (encodedEmail) email = decodeEmail(encodedEmail).split("?")[0];
        else return null;
        const recipients = email.toLowerCase().split(/[,;]/).map((item)=>item.trim()).filter(Boolean);
        if (!recipients.length) return null;
        return {
            type: "email",
            own: recipients.every((recipient)=>ownEmailDomains.has(recipient.split("@")[1])),
            ignored: false
        };
    }
    function trackContact(event) {
        if (event.type === "auxclick" ? event.button !== 1 : event.button > 0) return;
        const target = event.target instanceof Element ? event.target : event.target?.parentElement;
        const link = target?.closest("a");
        if (!link) return;
        const contact = getContact(link);
        if (!contact) return;
        // Plausible's class handler runs in the bubble phase. Remove only legacy
        // contact-event names from this click path before it runs, preventing a
        // second event. Saved WordPress content and other custom goals stay intact.
        for(let element = target; element; element = element.parentElement){
            for (const className of Array.from(element.classList))if (legacyContactClass.test(className)) element.classList.remove(className);
        }
        if (contact.ignored || link.closest(".himml-no-contact-tracking")) return;
        // Use the existing plugin instance/queue and its exclusions. Never initialize
        // Plausible ourselves or bypass disabled tracking for logged-in editors.
        if (typeof window.plausible !== "function") return;
        const position = link.closest("header") ? "header" : link.closest("footer") ? "footer" : "content";
        const props = {
            position: position
        };
        const name = contact.own ? contact.type + "click" : "externalcontactclick";
        if (!contact.own) props.type = contact.type;
        window.plausible(name, {
            props: props
        });
    }
    // Delegation also covers new blocks, mobile menus and nested SVG/icon clicks.
    // Keyboard activation and touch taps generate click events without extra handlers.
    document.addEventListener("click", trackContact, true);
    document.addEventListener("auxclick", trackContact, true);
})();


// Mobile menu focus handling lives in mobile-navigation.js.
const $c6200798eb449420$var$initHeader2026Menus = ()=>{
    const stickyMenus = Array.from(document.querySelectorAll(".header-2026 .sticky-menu, .header-2026 #sticky-menu"));
    if (stickyMenus.length === 0) return;
    const compactClassName = "is-compact";
    const compactThresholdPx = 14;
    let compactStateTicking = false;
    const updateCompactMenus = ()=>{
        compactStateTicking = false;
        const shouldCompact = window.scrollY > compactThresholdPx;
        stickyMenus.forEach((menu)=>{
            menu.classList.toggle(compactClassName, shouldCompact);
        });
    };
    const queueCompactUpdate = ()=>{
        if (compactStateTicking) return;
        compactStateTicking = true;
        window.requestAnimationFrame(updateCompactMenus);
    };
    updateCompactMenus();
    window.addEventListener("scroll", queueCompactUpdate, {
        passive: true
    });
    window.addEventListener("resize", queueCompactUpdate, {
        passive: true
    });
};
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $c6200798eb449420$var$initHeader2026Menus);
else $c6200798eb449420$var$initHeader2026Menus();


class $d055c2aed7a75f75$export$63bc083c14074060 {
    constructor(animations){
        // Bound to accomadate common `return animation.stop` pattern
        this.stop = ()=>this.runAll("stop");
        this.animations = animations.filter(Boolean);
    }
    get finished() {
        return Promise.all(this.animations.map((animation)=>animation.finished));
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */ getAll(propName) {
        return this.animations[0][propName];
    }
    setAll(propName, newValue) {
        for(let i = 0; i < this.animations.length; i++)this.animations[i][propName] = newValue;
    }
    attachTimeline(timeline) {
        const subscriptions = this.animations.map((animation)=>animation.attachTimeline(timeline));
        return ()=>{
            subscriptions.forEach((cancel, i)=>{
                cancel && cancel();
                this.animations[i].stop();
            });
        };
    }
    get time() {
        return this.getAll("time");
    }
    set time(time) {
        this.setAll("time", time);
    }
    get speed() {
        return this.getAll("speed");
    }
    set speed(speed) {
        this.setAll("speed", speed);
    }
    get state() {
        return this.getAll("state");
    }
    get startTime() {
        return this.getAll("startTime");
    }
    get duration() {
        return $d055c2aed7a75f75$var$getMax(this.animations, "duration");
    }
    get iterationDuration() {
        return $d055c2aed7a75f75$var$getMax(this.animations, "iterationDuration");
    }
    runAll(methodName) {
        this.animations.forEach((controls)=>controls[methodName]());
    }
    play() {
        this.runAll("play");
    }
    pause() {
        this.runAll("pause");
    }
    cancel() {
        this.runAll("cancel");
    }
    complete() {
        this.runAll("complete");
    }
}
function $d055c2aed7a75f75$var$getMax(animations, propName) {
    let max = 0;
    for(let i = 0; i < animations.length; i++){
        const value = animations[i][propName];
        if (value !== null && value > max) max = value;
    }
    return max;
}


class $ae2001463fda0404$export$77cf9b7b4d0397cf extends (0, $d055c2aed7a75f75$export$63bc083c14074060) {
    then(onResolve, _onReject) {
        return this.finished.finally(onResolve).then(()=>{});
    }
}


function $8e6f83cd8e8d205a$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $8e6f83cd8e8d205a$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $8e6f83cd8e8d205a$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}



class $559fb93c0e5925ed$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $8e6f83cd8e8d205a$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $8e6f83cd8e8d205a$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}

/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $ecc46a4789db2f8b$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $252c15636d941e6e$export$dd826089e3c5e502 = {};


/*#__NO_SIDE_EFFECTS__*/ const $acf123bf92e82acf$export$8793edee2d425525 = (any)=>any;



const $6ea25b7c8cdb5b24$export$71ecace0a033b35a = [
    "setup",
    "read",
    "resolveKeyframes",
    "preUpdate",
    "update",
    "preRender",
    "render",
    "postRender"
];


const $ea8eaf9a1bafcb0c$export$84ce9a476f53d110 = {
    value: null,
    addProjectionMetrics: null
};


function $ff1124039211b9f4$export$b995e5e85f5c8289(runNextFrame, stepName) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    let numCalls = 0;
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        numCalls++;
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            // Swap this frame and the next to avoid GC
            const prevFrame = thisFrame;
            thisFrame = nextFrame;
            nextFrame = prevFrame;
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            /**
             * If we're recording stats then
             */ if (stepName && (0, $ea8eaf9a1bafcb0c$export$84ce9a476f53d110).value) (0, $ea8eaf9a1bafcb0c$export$84ce9a476f53d110).value.frameloop[stepName].push(numCalls);
            numCalls = 0;
            // Clear the frame so no callbacks remain. This is to avoid
            // memory leaks should this render step not run for a while.
            thisFrame.clear();
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $f47fcc496681f604$var$maxElapsed = 40;
function $f47fcc496681f604$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = (0, $6ea25b7c8cdb5b24$export$71ecace0a033b35a).reduce((acc, key)=>{
        acc[key] = (0, $ff1124039211b9f4$export$b995e5e85f5c8289)(flagRunNextFrame, allowKeepAlive ? key : undefined);
        return acc;
    }, {});
    const { setup: setup, read: read, resolveKeyframes: resolveKeyframes, preUpdate: preUpdate, update: update, preRender: preRender, render: render, postRender: postRender } = steps;
    const processBatch = ()=>{
        const useManualTiming = (0, $252c15636d941e6e$export$dd826089e3c5e502).useManualTiming;
        const timestamp = useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        if (!useManualTiming) state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $f47fcc496681f604$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        setup.process(state);
        read.process(state);
        resolveKeyframes.process(state);
        preUpdate.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = (0, $6ea25b7c8cdb5b24$export$71ecace0a033b35a).reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < (0, $6ea25b7c8cdb5b24$export$71ecace0a033b35a).length; i++)steps[(0, $6ea25b7c8cdb5b24$export$71ecace0a033b35a)[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $efc9740269028631$export$2cef06c20297c17d, cancel: $efc9740269028631$export$ec99c0ef4978dccb, state: $efc9740269028631$export$fff89137e9e818ce, steps: $efc9740269028631$export$1811c3a7e3af92f0 } = /* @__PURE__ */ (0, $f47fcc496681f604$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $acf123bf92e82acf$export$8793edee2d425525), true);


let $ecd2e69909b240c8$var$now;
function $ecd2e69909b240c8$var$clearTime() {
    $ecd2e69909b240c8$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $ecd2e69909b240c8$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($ecd2e69909b240c8$var$now === undefined) $ecd2e69909b240c8$export$2da9be4cfdb689b1.set((0, $efc9740269028631$export$fff89137e9e818ce).isProcessing || (0, $252c15636d941e6e$export$dd826089e3c5e502).useManualTiming ? (0, $efc9740269028631$export$fff89137e9e818ce).timestamp : performance.now());
        return $ecd2e69909b240c8$var$now;
    },
    set: (newTime)=>{
        $ecd2e69909b240c8$var$now = newTime;
        queueMicrotask($ecd2e69909b240c8$var$clearTime);
    }
};



/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $a82ff1c7e83e3798$var$MAX_VELOCITY_DELTA = 30;
const $a82ff1c7e83e3798$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $a82ff1c7e83e3798$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $a82ff1c7e83e3798$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     */ constructor(init, options = {}){
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v)=>{
            const currentTime = (0, $ecd2e69909b240c8$export$2da9be4cfdb689b1).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev) {
                this.events.change?.notify(this.current);
                if (this.dependents) for (const dependent of this.dependents)dependent.dirty();
            }
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $ecd2e69909b240c8$export$2da9be4cfdb689b1).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $a82ff1c7e83e3798$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $559fb93c0e5925ed$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $efc9740269028631$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v) {
        if (!this.passiveEffect) this.updateAndNotify(v);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    dirty() {
        this.events.change?.notify(this.current);
    }
    addDependent(dependent) {
        if (!this.dependents) this.dependents = new Set();
        this.dependents.add(dependent);
    }
    removeDependent(dependent) {
        if (this.dependents) this.dependents.delete(dependent);
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($a82ff1c7e83e3798$export$67fcd818a264039d.current) $a82ff1c7e83e3798$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $ecd2e69909b240c8$export$2da9be4cfdb689b1).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $a82ff1c7e83e3798$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $a82ff1c7e83e3798$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $ecc46a4789db2f8b$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.dependents?.clear();
        this.events.destroy?.notify();
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $a82ff1c7e83e3798$export$ce8bdc721e76545f(init, options) {
    return new $a82ff1c7e83e3798$export$8cea36d14ee64562(init, options);
}

const $d03597240d130486$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};

/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ /*#__NO_SIDE_EFFECTS__*/ const $c8fe15c475fa19ba$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
/*#__NO_SIDE_EFFECTS__*/ const $c8fe15c475fa19ba$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;


let $1f68be864a33a611$export$491112666e282270 = ()=>{};
let $1f68be864a33a611$export$f5708dca728d7177 = ()=>{};
var $1f68be864a33a611$var$check, $1f68be864a33a611$var$message, $1f68be864a33a611$var$errorCode, $1f68be864a33a611$var$check1, $1f68be864a33a611$var$message1, $1f68be864a33a611$var$errorCode1;


const $2cb279345489b9e2$export$66d3851e2b1ec912 = (easing, duration, resolution = 10 // as milliseconds
)=>{
    let points = "";
    const numPoints = Math.max(Math.round(duration / resolution), 2);
    for(let i = 0; i < numPoints; i++)points += Math.round(easing(i / (numPoints - 1)) * 10000) / 10000 + ", ";
    return `linear(${points.substring(0, points.length - 2)})`;
};


/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $a3d0fc11d0c6bf6e$export$f4ff70a5b4808fd8 = 20000;
function $a3d0fc11d0c6bf6e$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $a3d0fc11d0c6bf6e$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $a3d0fc11d0c6bf6e$export$f4ff70a5b4808fd8 ? Infinity : duration;
}




/**
 * Create a progress => progress easing function from a generator.
 */ function $a57f79c36e05a6e7$export$7f1511d09ee75a99(options, scale = 100, createGenerator) {
    const generator = createGenerator({
        ...options,
        keyframes: [
            0,
            scale
        ]
    });
    const duration = Math.min((0, $a3d0fc11d0c6bf6e$export$cbdd6b3d40ea54e2)(generator), (0, $a3d0fc11d0c6bf6e$export$f4ff70a5b4808fd8));
    return {
        type: "keyframes",
        ease: (progress)=>{
            return generator.next(duration * progress).value / scale;
        },
        duration: (0, $c8fe15c475fa19ba$export$f64c3bfbc58eec0f)(duration)
    };
}


const $cb6a5de6c9fd4114$var$springDefaults = {
    // Default spring physics
    stiffness: 100,
    damping: 10,
    mass: 1.0,
    velocity: 0.0,
    // Default duration/bounce-based options
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    // Rest thresholds
    restSpeed: {
        granular: 0.01,
        default: 2
    },
    restDelta: {
        granular: 0.005,
        default: 0.5
    },
    // Limits
    minDuration: 0.01,
    maxDuration: 10.0,
    minDamping: 0.05,
    maxDamping: 1
};
function $cb6a5de6c9fd4114$var$calcAngularFreq(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}
const $cb6a5de6c9fd4114$var$rootIterations = 12;
function $cb6a5de6c9fd4114$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $cb6a5de6c9fd4114$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
/**
 * This is ported from the Framer implementation of duration-based spring resolution.
 */ const $cb6a5de6c9fd4114$var$safeMin = 0.001;
function $cb6a5de6c9fd4114$var$findSpring({ duration: duration = $cb6a5de6c9fd4114$var$springDefaults.duration, bounce: bounce = $cb6a5de6c9fd4114$var$springDefaults.bounce, velocity: velocity = $cb6a5de6c9fd4114$var$springDefaults.velocity, mass: mass = $cb6a5de6c9fd4114$var$springDefaults.mass }) {
    let envelope;
    let derivative;
    (0, $1f68be864a33a611$export$491112666e282270)(duration <= (0, $c8fe15c475fa19ba$export$fc3e7e8557f8c8c7)($cb6a5de6c9fd4114$var$springDefaults.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $d03597240d130486$export$7d15b64cf5a3a4c4)($cb6a5de6c9fd4114$var$springDefaults.minDamping, $cb6a5de6c9fd4114$var$springDefaults.maxDamping, dampingRatio);
    duration = (0, $d03597240d130486$export$7d15b64cf5a3a4c4)($cb6a5de6c9fd4114$var$springDefaults.minDuration, $cb6a5de6c9fd4114$var$springDefaults.maxDuration, (0, $c8fe15c475fa19ba$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $cb6a5de6c9fd4114$var$calcAngularFreq(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $cb6a5de6c9fd4114$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $cb6a5de6c9fd4114$var$calcAngularFreq(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $cb6a5de6c9fd4114$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$cb6a5de6c9fd4114$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $cb6a5de6c9fd4114$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $c8fe15c475fa19ba$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: $cb6a5de6c9fd4114$var$springDefaults.stiffness,
        damping: $cb6a5de6c9fd4114$var$springDefaults.damping,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $cb6a5de6c9fd4114$var$durationKeys = [
    "duration",
    "bounce"
];
const $cb6a5de6c9fd4114$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $cb6a5de6c9fd4114$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $cb6a5de6c9fd4114$var$getSpringOptions(options) {
    let springOptions = {
        velocity: $cb6a5de6c9fd4114$var$springDefaults.velocity,
        stiffness: $cb6a5de6c9fd4114$var$springDefaults.stiffness,
        damping: $cb6a5de6c9fd4114$var$springDefaults.damping,
        mass: $cb6a5de6c9fd4114$var$springDefaults.mass,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$cb6a5de6c9fd4114$var$isSpringType(options, $cb6a5de6c9fd4114$var$physicsKeys) && $cb6a5de6c9fd4114$var$isSpringType(options, $cb6a5de6c9fd4114$var$durationKeys)) {
        // Time-defined springs should ignore inherited velocity.
        // Velocity from interrupted animations can cause findSpring()
        // to compute wildly different spring parameters, leading to
        // massive oscillation on small-range animations.
        springOptions.velocity = 0;
        if (options.visualDuration) {
            const visualDuration = options.visualDuration;
            const root = 2 * Math.PI / (visualDuration * 1.2);
            const stiffness = root * root;
            const damping = 2 * (0, $d03597240d130486$export$7d15b64cf5a3a4c4)(0.05, 1, 1 - (options.bounce || 0)) * Math.sqrt(stiffness);
            springOptions = {
                ...springOptions,
                mass: $cb6a5de6c9fd4114$var$springDefaults.mass,
                stiffness: stiffness,
                damping: damping
            };
        } else {
            const derived = $cb6a5de6c9fd4114$var$findSpring({
                ...options,
                velocity: 0
            });
            springOptions = {
                ...springOptions,
                ...derived,
                mass: $cb6a5de6c9fd4114$var$springDefaults.mass
            };
            springOptions.isResolvedFromDuration = true;
        }
    }
    return springOptions;
}
function $cb6a5de6c9fd4114$export$b36281d89752ae66(optionsOrVisualDuration = $cb6a5de6c9fd4114$var$springDefaults.visualDuration, bounce = $cb6a5de6c9fd4114$var$springDefaults.bounce) {
    const options = typeof optionsOrVisualDuration !== "object" ? {
        visualDuration: optionsOrVisualDuration,
        keyframes: [
            0,
            1
        ],
        bounce: bounce
    } : optionsOrVisualDuration;
    let { restSpeed: restSpeed, restDelta: restDelta } = options;
    const origin = options.keyframes[0];
    const target = options.keyframes[options.keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $cb6a5de6c9fd4114$var$getSpringOptions({
        ...options,
        velocity: -(0, $c8fe15c475fa19ba$export$f64c3bfbc58eec0f)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $c8fe15c475fa19ba$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? $cb6a5de6c9fd4114$var$springDefaults.restSpeed.granular : $cb6a5de6c9fd4114$var$springDefaults.restSpeed.default);
    restDelta || (restDelta = isGranularScale ? $cb6a5de6c9fd4114$var$springDefaults.restDelta.granular : $cb6a5de6c9fd4114$var$springDefaults.restDelta.default);
    let resolveSpring;
    let resolveVelocity;
    // Underdamped coefficients, hoisted for use in the inlined next() hot path
    let angularFreq;
    let A;
    let sinCoeff;
    let cosCoeff;
    if (dampingRatio < 1) {
        angularFreq = $cb6a5de6c9fd4114$var$calcAngularFreq(undampedAngularFreq, dampingRatio);
        A = (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq;
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * (A * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
        // Analytical derivative of underdamped spring (px/ms)
        sinCoeff = dampingRatio * undampedAngularFreq * A + initialDelta * angularFreq;
        cosCoeff = dampingRatio * undampedAngularFreq * initialDelta - A * angularFreq;
        resolveVelocity = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return envelope * (sinCoeff * Math.sin(angularFreq * t) + cosCoeff * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) {
        // Critically damped spring
        resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
        // Analytical derivative of critically damped spring (px/ms)
        const C = initialVelocity + undampedAngularFreq * initialDelta;
        resolveVelocity = (t)=>Math.exp(-undampedAngularFreq * t) * (undampedAngularFreq * C * t - initialVelocity);
    } else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
        // Analytical derivative of overdamped spring (px/ms)
        const P = (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / dampedAngularFreq;
        const sinhCoeff = dampingRatio * undampedAngularFreq * P - initialDelta * dampedAngularFreq;
        const coshCoeff = dampingRatio * undampedAngularFreq * initialDelta - P * dampedAngularFreq;
        resolveVelocity = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return envelope * (sinhCoeff * Math.sinh(freqForT) + coshCoeff * Math.cosh(freqForT));
        };
    }
    const generator = {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        velocity: (t)=>(0, $c8fe15c475fa19ba$export$fc3e7e8557f8c8c7)(resolveVelocity(t)),
        next: (t)=>{
            /**
             * For underdamped physics springs we need both position and
             * velocity each tick. Compute shared trig values once to avoid
             * duplicate Math.exp/sin/cos calls on the hot path.
             */ if (!isResolvedFromDuration && dampingRatio < 1) {
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                const sin = Math.sin(angularFreq * t);
                const cos = Math.cos(angularFreq * t);
                const current = target - envelope * (A * sin + initialDelta * cos);
                const currentVelocity = (0, $c8fe15c475fa19ba$export$fc3e7e8557f8c8c7)(envelope * (sinCoeff * sin + cosCoeff * cos));
                state.done = Math.abs(currentVelocity) <= restSpeed && Math.abs(target - current) <= restDelta;
                state.value = state.done ? target : current;
                return state;
            }
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                const currentVelocity = (0, $c8fe15c475fa19ba$export$fc3e7e8557f8c8c7)(resolveVelocity(t));
                state.done = Math.abs(currentVelocity) <= restSpeed && Math.abs(target - current) <= restDelta;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        },
        toString: ()=>{
            const calculatedDuration = Math.min((0, $a3d0fc11d0c6bf6e$export$cbdd6b3d40ea54e2)(generator), (0, $a3d0fc11d0c6bf6e$export$f4ff70a5b4808fd8));
            const easing = (0, $2cb279345489b9e2$export$66d3851e2b1ec912)((progress)=>generator.next(calculatedDuration * progress).value, calculatedDuration, 30);
            return calculatedDuration + "ms " + easing;
        },
        toTransition: ()=>{}
    };
    return generator;
}
$cb6a5de6c9fd4114$export$b36281d89752ae66.applyToOptions = (options)=>{
    const generatorOptions = (0, $a57f79c36e05a6e7$export$7f1511d09ee75a99)(options, 100, $cb6a5de6c9fd4114$export$b36281d89752ae66);
    options.ease = generatorOptions.ease;
    options.duration = (0, $c8fe15c475fa19ba$export$fc3e7e8557f8c8c7)(generatorOptions.duration);
    options.type = "keyframes";
    return options;
};


/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ /*#__NO_SIDE_EFFECTS__*/ const $f5eb66e60bd17fc7$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};


/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $bb85245f2bb1740c$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};


function $1168e148392bd976$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $f5eb66e60bd17fc7$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $bb85245f2bb1740c$export$3bb0b4ff1037b8dd)(min, 1, offsetProgress));
    }
}


function $e40cb325918ea9b6$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $1168e148392bd976$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}

function $a95a3e57f039e5f3$export$6ab7812f1bac68be(type) {
    return typeof type === "function" && "applyToOptions" in type;
}

const $332ca6f8f18741ec$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);


const $4df8400c4ec4c1d7$export$4997ffc0176396a6 = (min, max, v)=>{
    const rangeSize = max - min;
    return ((v - min) % rangeSize + rangeSize) % rangeSize + min;
};


const $6b4f22c3afa23da5$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};


function $9095ec0d195e2a04$export$41c5e731255a462(easing, i) {
    return (0, $6b4f22c3afa23da5$export$216948827bbdc797)(easing) ? easing[(0, $4df8400c4ec4c1d7$export$4997ffc0176396a6)(0, easing.length, i)] : easing;
}


function $04a3ae0e7d2ff9fd$export$90ceba2564a894f8(elementOrSelector, scope, selectorCache) {
    if (elementOrSelector == null) return [];
    if (elementOrSelector instanceof EventTarget) return [
        elementOrSelector
    ];
    else if (typeof elementOrSelector === "string") {
        let root = document;
        if (scope) root = scope.current;
        const elements = selectorCache?.[elementOrSelector] ?? root.querySelectorAll(elementOrSelector);
        return elements ? Array.from(elements) : [];
    }
    return Array.from(elementOrSelector).filter((element)=>element != null);
}


function $90f32defc8ee2bd1$export$d276bfce3b1077ca(keyframes) {
    return typeof keyframes === "object" && !Array.isArray(keyframes);
}


function $4dc00288ce198975$export$92b2aefc56600400(subject, keyframes, scope, selectorCache) {
    if (subject == null) return [];
    if (typeof subject === "string" && (0, $90f32defc8ee2bd1$export$d276bfce3b1077ca)(keyframes)) return (0, $04a3ae0e7d2ff9fd$export$90ceba2564a894f8)(subject, scope, selectorCache);
    else if (subject instanceof NodeList) return Array.from(subject);
    else if (Array.isArray(subject)) return subject.filter((s)=>s != null);
    else return [
        subject
    ];
}


function $cc95ffa8dce6d61d$export$fcfa02e469c39006(duration, repeat, _repeatDelay) {
    return duration * (repeat + 1);
}


/**
 * Given a absolute or relative time definition and current/prev time state of the sequence,
 * calculate an absolute time for the next keyframes.
 */ function $f4445a5c7f84cce9$export$83ccd85155ba9791(current, next, prev, labels) {
    if (typeof next === "number") return next;
    else if (next.startsWith("-") || next.startsWith("+")) return Math.max(0, current + parseFloat(next));
    else if (next === "<") return prev;
    else if (next.startsWith("<")) return Math.max(0, prev + parseFloat(next.slice(1)));
    else return labels.get(next) ?? current;
}




function $602fc9650eac32cd$export$6f93cdbb78924b88(sequence, startTime, endTime) {
    for(let i = 0; i < sequence.length; i++){
        const keyframe = sequence[i];
        if (keyframe.at > startTime && keyframe.at < endTime) {
            (0, $8e6f83cd8e8d205a$export$fe2d9b4e03920b4c)(sequence, keyframe);
            // If we remove this item we have to push the pointer back one
            i--;
        }
    }
}
function $602fc9650eac32cd$export$89dfa6760a9f76e7(sequence, keyframes, easing, offset, startTime, endTime) {
    /**
     * Erase every existing value between currentTime and targetTime,
     * this will essentially splice this timeline into any currently
     * defined ones.
     */ $602fc9650eac32cd$export$6f93cdbb78924b88(sequence, startTime, endTime);
    for(let i = 0; i < keyframes.length; i++)sequence.push({
        value: keyframes[i],
        at: (0, $bb85245f2bb1740c$export$3bb0b4ff1037b8dd)(startTime, endTime, offset[i]),
        easing: (0, $9095ec0d195e2a04$export$41c5e731255a462)(easing, i)
    });
}


/**
 * Take an array of times that represent repeated keyframes. For instance
 * if we have original times of [0, 0.5, 1] then our repeated times will
 * be [0, 0.5, 1, 1, 1.5, 2]. Loop over the times and scale them back
 * down to a 0-1 scale.
 */ function $924080bb596716f1$export$989461f373b2c60a(times, repeat) {
    for(let i = 0; i < times.length; i++)times[i] = times[i] / (repeat + 1);
}


function $8abafe1542550fa0$export$66dd3fbf44e05bd9(a, b) {
    if (a.at === b.at) {
        if (a.value === null) return 1;
        if (b.value === null) return -1;
        return 0;
    } else return a.at - b.at;
}


const $eec42b624b7aefb8$var$defaultSegmentEasing = "easeInOut";
const $eec42b624b7aefb8$var$MAX_REPEAT = 20;
function $eec42b624b7aefb8$export$1f0f44b51a4b2f73(sequence, { defaultTransition: defaultTransition = {}, ...sequenceTransition } = {}, scope, generators) {
    const defaultDuration = defaultTransition.duration || 0.3;
    const animationDefinitions = new Map();
    const sequences = new Map();
    const elementCache = {};
    const timeLabels = new Map();
    let prevTime = 0;
    let currentTime = 0;
    let totalDuration = 0;
    /**
     * Build the timeline by mapping over the sequence array and converting
     * the definitions into keyframes and offsets with absolute time values.
     * These will later get converted into relative offsets in a second pass.
     */ for(let i = 0; i < sequence.length; i++){
        const segment = sequence[i];
        /**
         * If this is a timeline label, mark it and skip the rest of this iteration.
         */ if (typeof segment === "string") {
            timeLabels.set(segment, currentTime);
            continue;
        } else if (!Array.isArray(segment)) {
            timeLabels.set(segment.name, (0, $f4445a5c7f84cce9$export$83ccd85155ba9791)(currentTime, segment.at, prevTime, timeLabels));
            continue;
        }
        let [subject, keyframes, transition = {}] = segment;
        /**
         * If a relative or absolute time value has been specified we need to resolve
         * it in relation to the currentTime.
         */ if (transition.at !== undefined) currentTime = (0, $f4445a5c7f84cce9$export$83ccd85155ba9791)(currentTime, transition.at, prevTime, timeLabels);
        /**
         * Keep track of the maximum duration in this definition. This will be
         * applied to currentTime once the definition has been parsed.
         */ let maxDuration = 0;
        const resolveValueSequence = (valueKeyframes, valueTransition, valueSequence, elementIndex = 0, numSubjects = 0)=>{
            const valueKeyframesAsList = $eec42b624b7aefb8$var$keyframesAsList(valueKeyframes);
            const { delay: delay = 0, times: times = (0, $e40cb325918ea9b6$export$24dbcec0b26e6d9d)(valueKeyframesAsList), type: type = defaultTransition.type || "keyframes", repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay = 0, ...remainingTransition } = valueTransition;
            let { ease: ease = defaultTransition.ease || "easeOut", duration: duration } = valueTransition;
            /**
             * Resolve stagger() if defined.
             */ const calculatedDelay = typeof delay === "function" ? delay(elementIndex, numSubjects) : delay;
            /**
             * If this animation should and can use a spring, generate a spring easing function.
             */ const numKeyframes = valueKeyframesAsList.length;
            const createGenerator = (0, $a95a3e57f039e5f3$export$6ab7812f1bac68be)(type) ? type : generators?.[type || "keyframes"];
            if (numKeyframes <= 2 && createGenerator) {
                /**
                 * As we're creating an easing function from a spring,
                 * ideally we want to generate it using the real distance
                 * between the two keyframes. However this isn't always
                 * possible - in these situations we use 0-100.
                 */ let absoluteDelta = 100;
                if (numKeyframes === 2 && $eec42b624b7aefb8$var$isNumberKeyframesArray(valueKeyframesAsList)) {
                    const delta = valueKeyframesAsList[1] - valueKeyframesAsList[0];
                    absoluteDelta = Math.abs(delta);
                }
                const springTransition = {
                    ...defaultTransition,
                    ...remainingTransition
                };
                if (duration !== undefined) springTransition.duration = (0, $c8fe15c475fa19ba$export$fc3e7e8557f8c8c7)(duration);
                const springEasing = (0, $a57f79c36e05a6e7$export$7f1511d09ee75a99)(springTransition, absoluteDelta, createGenerator);
                ease = springEasing.ease;
                duration = springEasing.duration;
            }
            duration ?? (duration = defaultDuration);
            const startTime = currentTime + calculatedDelay;
            /**
             * If there's only one time offset of 0, fill in a second with length 1
             */ if (times.length === 1 && times[0] === 0) times[1] = 1;
            /**
             * Fill out if offset if fewer offsets than keyframes
             */ const remainder = times.length - valueKeyframesAsList.length;
            remainder > 0 && (0, $1168e148392bd976$export$dafee61230cf05c6)(times, remainder);
            /**
             * If only one value has been set, ie [1], push a null to the start of
             * the keyframe array. This will let us mark a keyframe at this point
             * that will later be hydrated with the previous value.
             */ valueKeyframesAsList.length === 1 && valueKeyframesAsList.unshift(null);
            /**
             * Handle repeat options
             */ if (repeat) {
                (0, $1f68be864a33a611$export$f5708dca728d7177)(repeat < $eec42b624b7aefb8$var$MAX_REPEAT, "Repeat count too high, must be less than 20", "repeat-count-high");
                duration = (0, $cc95ffa8dce6d61d$export$fcfa02e469c39006)(duration, repeat);
                const originalKeyframes = [
                    ...valueKeyframesAsList
                ];
                const originalTimes = [
                    ...times
                ];
                ease = Array.isArray(ease) ? [
                    ...ease
                ] : [
                    ease
                ];
                const originalEase = [
                    ...ease
                ];
                for(let repeatIndex = 0; repeatIndex < repeat; repeatIndex++){
                    valueKeyframesAsList.push(...originalKeyframes);
                    for(let keyframeIndex = 0; keyframeIndex < originalKeyframes.length; keyframeIndex++){
                        times.push(originalTimes[keyframeIndex] + (repeatIndex + 1));
                        ease.push(keyframeIndex === 0 ? "linear" : (0, $9095ec0d195e2a04$export$41c5e731255a462)(originalEase, keyframeIndex - 1));
                    }
                }
                (0, $924080bb596716f1$export$989461f373b2c60a)(times, repeat);
            }
            const targetTime = startTime + duration;
            /**
             * Add keyframes, mapping offsets to absolute time.
             */ (0, $602fc9650eac32cd$export$89dfa6760a9f76e7)(valueSequence, valueKeyframesAsList, ease, times, startTime, targetTime);
            maxDuration = Math.max(calculatedDelay + duration, maxDuration);
            totalDuration = Math.max(targetTime, totalDuration);
        };
        if ((0, $332ca6f8f18741ec$export$605d60a2578142d3)(subject)) {
            const subjectSequence = $eec42b624b7aefb8$var$getSubjectSequence(subject, sequences);
            resolveValueSequence(keyframes, transition, $eec42b624b7aefb8$var$getValueSequence("default", subjectSequence));
        } else {
            const subjects = (0, $4dc00288ce198975$export$92b2aefc56600400)(subject, keyframes, scope, elementCache);
            const numSubjects = subjects.length;
            /**
             * For every element in this segment, process the defined values.
             */ for(let subjectIndex = 0; subjectIndex < numSubjects; subjectIndex++){
                /**
                 * Cast necessary, but we know these are of this type
                 */ keyframes;
                transition;
                const thisSubject = subjects[subjectIndex];
                const subjectSequence = $eec42b624b7aefb8$var$getSubjectSequence(thisSubject, sequences);
                for(const key in keyframes)resolveValueSequence(keyframes[key], $eec42b624b7aefb8$export$7c1391340308742e(transition, key), $eec42b624b7aefb8$var$getValueSequence(key, subjectSequence), subjectIndex, numSubjects);
            }
        }
        prevTime = currentTime;
        currentTime += maxDuration;
    }
    /**
     * For every element and value combination create a new animation.
     */ sequences.forEach((valueSequences, element)=>{
        for(const key in valueSequences){
            const valueSequence = valueSequences[key];
            /**
             * Arrange all the keyframes in ascending time order.
             */ valueSequence.sort((0, $8abafe1542550fa0$export$66dd3fbf44e05bd9));
            const keyframes = [];
            const valueOffset = [];
            const valueEasing = [];
            /**
             * For each keyframe, translate absolute times into
             * relative offsets based on the total duration of the timeline.
             */ for(let i = 0; i < valueSequence.length; i++){
                const { at: at, value: value, easing: easing } = valueSequence[i];
                keyframes.push(value);
                valueOffset.push((0, $f5eb66e60bd17fc7$export$504d7abb21fa8c9)(0, totalDuration, at));
                valueEasing.push(easing || "easeOut");
            }
            /**
             * If the first keyframe doesn't land on offset: 0
             * provide one by duplicating the initial keyframe. This ensures
             * it snaps to the first keyframe when the animation starts.
             */ if (valueOffset[0] !== 0) {
                valueOffset.unshift(0);
                keyframes.unshift(keyframes[0]);
                valueEasing.unshift($eec42b624b7aefb8$var$defaultSegmentEasing);
            }
            /**
             * If the last keyframe doesn't land on offset: 1
             * provide one with a null wildcard value. This will ensure it
             * stays static until the end of the animation.
             */ if (valueOffset[valueOffset.length - 1] !== 1) {
                valueOffset.push(1);
                keyframes.push(null);
            }
            if (!animationDefinitions.has(element)) animationDefinitions.set(element, {
                keyframes: {},
                transition: {}
            });
            const definition = animationDefinitions.get(element);
            definition.keyframes[key] = keyframes;
            /**
             * Exclude `type` from defaultTransition since springs have been
             * converted to duration-based easing functions in resolveValueSequence.
             * Including `type: "spring"` would cause JSAnimation to error when
             * the merged keyframes array has more than 2 keyframes.
             */ const { type: _type, ...remainingDefaultTransition } = defaultTransition;
            definition.transition[key] = {
                ...remainingDefaultTransition,
                duration: totalDuration,
                ease: valueEasing,
                times: valueOffset,
                ...sequenceTransition
            };
        }
    });
    return animationDefinitions;
}
function $eec42b624b7aefb8$var$getSubjectSequence(subject, sequences) {
    !sequences.has(subject) && sequences.set(subject, {});
    return sequences.get(subject);
}
function $eec42b624b7aefb8$var$getValueSequence(name, sequences) {
    if (!sequences[name]) sequences[name] = [];
    return sequences[name];
}
function $eec42b624b7aefb8$var$keyframesAsList(keyframes) {
    return Array.isArray(keyframes) ? keyframes : [
        keyframes
    ];
}
function $eec42b624b7aefb8$export$7c1391340308742e(transition, key) {
    return transition && transition[key] ? {
        ...transition,
        ...transition[key]
    } : {
        ...transition
    };
}
const $eec42b624b7aefb8$var$isNumber = (keyframe)=>typeof keyframe === "number";
const $eec42b624b7aefb8$var$isNumberKeyframesArray = (keyframes)=>keyframes.every($eec42b624b7aefb8$var$isNumber);





/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $eea2d50cab370107$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $eea2d50cab370107$export$a4627e546088548d = (...transformers)=>transformers.reduce($eea2d50cab370107$var$combineFunctions);



const $60c98e7bc69ece91$export$d921fb2475e2900c = {
    layout: 0,
    mainThread: 0,
    waapi: 0
};



const $021b423722640b5d$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $021b423722640b5d$export$9de1236619d9e756 = /*@__PURE__*/ $021b423722640b5d$var$checkStringStartsWith("--");
const $021b423722640b5d$var$startsAsVariableToken = /*@__PURE__*/ $021b423722640b5d$var$checkStringStartsWith("var(--");
const $021b423722640b5d$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $021b423722640b5d$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $021b423722640b5d$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $021b423722640b5d$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;
/**
 * Check if a value contains a CSS variable anywhere (e.g. inside calc()).
 * Unlike isCSSVariableToken which checks if the value IS a var() token,
 * this checks if the value CONTAINS var() somewhere in the string.
 */ function $021b423722640b5d$export$df8f90ab5d0b05fa(value) {
    if (typeof value !== "string") return false;
    // Strip comments to avoid false positives
    return value.split("/*")[0].includes("var(--");
}




const $a4fcdad035128669$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $a4fcdad035128669$export$58f0f39f63f3cf42 = {
    ...$a4fcdad035128669$export$98e628dec113755e,
    transform: (v)=>(0, $d03597240d130486$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $a4fcdad035128669$export$dcdf75081b88279d = {
    ...$a4fcdad035128669$export$98e628dec113755e,
    default: 1
};


// If this number is a decimal, make it just five decimal places
// to avoid exponents
const $2193df605f12885e$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;


const $15219eed37aadc82$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;


function $7ce17f0738f0d688$export$b931b78cbb3caf86(v) {
    return v == null;
}


const $fc94395f82827fae$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;


/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $d70dacd17f80cd01$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean(typeof v === "string" && (0, $fc94395f82827fae$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && !(0, $7ce17f0738f0d688$export$b931b78cbb3caf86)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $d70dacd17f80cd01$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (typeof v !== "string") return v;
        const [a, b, c, alpha] = v.match((0, $15219eed37aadc82$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $db8f3dc4a1301e8a$var$clampRgbUnit = (v)=>(0, $d03597240d130486$export$7d15b64cf5a3a4c4)(0, 255, v);
const $db8f3dc4a1301e8a$export$7a99c86b5b1f4c9e = {
    ...(0, $a4fcdad035128669$export$98e628dec113755e),
    transform: (v)=>Math.round($db8f3dc4a1301e8a$var$clampRgbUnit(v))
};
const $db8f3dc4a1301e8a$export$4e46ac54fc82cf3b = {
    test: /*@__PURE__*/ (0, $d70dacd17f80cd01$export$2c8400d58aca05e)("rgb", "red"),
    parse: /*@__PURE__*/ (0, $d70dacd17f80cd01$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $db8f3dc4a1301e8a$export$7a99c86b5b1f4c9e.transform(red) + ", " + $db8f3dc4a1301e8a$export$7a99c86b5b1f4c9e.transform(green) + ", " + $db8f3dc4a1301e8a$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $2193df605f12885e$export$83d2e9e3e4ee39ed)((0, $a4fcdad035128669$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $7d3c4430d6be76c0$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $7d3c4430d6be76c0$export$834dfc94dde4b3d8 = {
    test: /*@__PURE__*/ (0, $d70dacd17f80cd01$export$2c8400d58aca05e)("#"),
    parse: $7d3c4430d6be76c0$var$parseHex,
    transform: (0, $db8f3dc4a1301e8a$export$4e46ac54fc82cf3b).transform
};



/*#__NO_SIDE_EFFECTS__*/ const $31304987b0919f83$var$createUnitType = (unit)=>({
        test: (v)=>typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $31304987b0919f83$export$41fc368e1a942b97 = /*@__PURE__*/ $31304987b0919f83$var$createUnitType("deg");
const $31304987b0919f83$export$626336c2cd4b14de = /*@__PURE__*/ $31304987b0919f83$var$createUnitType("%");
const $31304987b0919f83$export$91c0eda1d06bf008 = /*@__PURE__*/ $31304987b0919f83$var$createUnitType("px");
const $31304987b0919f83$export$f91e8c45a95a32f2 = /*@__PURE__*/ $31304987b0919f83$var$createUnitType("vh");
const $31304987b0919f83$export$aed3d7b7d206c196 = /*@__PURE__*/ $31304987b0919f83$var$createUnitType("vw");
const $31304987b0919f83$export$44e2e1705876d7ed = /*@__PURE__*/ (()=>({
        ...$31304987b0919f83$export$626336c2cd4b14de,
        parse: (v)=>$31304987b0919f83$export$626336c2cd4b14de.parse(v) / 100,
        transform: (v)=>$31304987b0919f83$export$626336c2cd4b14de.transform(v * 100)
    }))();




const $aea83326166976b9$export$810b04175080204c = {
    test: /*@__PURE__*/ (0, $d70dacd17f80cd01$export$2c8400d58aca05e)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, $d70dacd17f80cd01$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $31304987b0919f83$export$626336c2cd4b14de).transform((0, $2193df605f12885e$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $31304987b0919f83$export$626336c2cd4b14de).transform((0, $2193df605f12885e$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $2193df605f12885e$export$83d2e9e3e4ee39ed)((0, $a4fcdad035128669$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $1f6a47b5445f6d2e$export$35e9368ef982300f = {
    test: (v)=>(0, $db8f3dc4a1301e8a$export$4e46ac54fc82cf3b).test(v) || (0, $7d3c4430d6be76c0$export$834dfc94dde4b3d8).test(v) || (0, $aea83326166976b9$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $db8f3dc4a1301e8a$export$4e46ac54fc82cf3b).test(v)) return (0, $db8f3dc4a1301e8a$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $aea83326166976b9$export$810b04175080204c).test(v)) return (0, $aea83326166976b9$export$810b04175080204c).parse(v);
        else return (0, $7d3c4430d6be76c0$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return typeof v === "string" ? v : v.hasOwnProperty("red") ? (0, $db8f3dc4a1301e8a$export$4e46ac54fc82cf3b).transform(v) : (0, $aea83326166976b9$export$810b04175080204c).transform(v);
    },
    getAnimatableNone: (v)=>{
        const parsed = $1f6a47b5445f6d2e$export$35e9368ef982300f.parse(v);
        parsed.alpha = 0;
        return $1f6a47b5445f6d2e$export$35e9368ef982300f.transform(parsed);
    }
};



const $42c304783d93abf2$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;




function $143d250b15433a18$var$test(v) {
    return isNaN(v) && typeof v === "string" && (v.match((0, $15219eed37aadc82$export$2444ca58c08448e4))?.length || 0) + (v.match((0, $42c304783d93abf2$export$740b69c5fad25dba))?.length || 0) > 0;
}
const $143d250b15433a18$var$NUMBER_TOKEN = "number";
const $143d250b15433a18$var$COLOR_TOKEN = "color";
const $143d250b15433a18$var$VAR_TOKEN = "var";
const $143d250b15433a18$var$VAR_FUNCTION_TOKEN = "var(";
const $143d250b15433a18$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $143d250b15433a18$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $143d250b15433a18$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($143d250b15433a18$var$complexRegex, (parsedValue)=>{
        if ((0, $1f6a47b5445f6d2e$export$35e9368ef982300f).test(parsedValue)) {
            indexes.color.push(i);
            types.push($143d250b15433a18$var$COLOR_TOKEN);
            values.push((0, $1f6a47b5445f6d2e$export$35e9368ef982300f).parse(parsedValue));
        } else if (parsedValue.startsWith($143d250b15433a18$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($143d250b15433a18$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($143d250b15433a18$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $143d250b15433a18$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($143d250b15433a18$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $143d250b15433a18$var$parseComplexValue(v) {
    return $143d250b15433a18$export$b61fc7c44bf646d5(v).values;
}
function $143d250b15433a18$var$buildTransformer({ split: split, types: types }) {
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $143d250b15433a18$var$NUMBER_TOKEN) output += (0, $2193df605f12885e$export$83d2e9e3e4ee39ed)(v[i]);
                else if (type === $143d250b15433a18$var$COLOR_TOKEN) output += (0, $1f6a47b5445f6d2e$export$35e9368ef982300f).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
function $143d250b15433a18$var$createTransformer(source) {
    return $143d250b15433a18$var$buildTransformer($143d250b15433a18$export$b61fc7c44bf646d5(source));
}
const $143d250b15433a18$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : (0, $1f6a47b5445f6d2e$export$35e9368ef982300f).test(v) ? (0, $1f6a47b5445f6d2e$export$35e9368ef982300f).getAnimatableNone(v) : v;
/**
 * Convert a parsed value to its zero equivalent, but preserve numbers
 * that act as divisors in CSS calc() expressions.
 *
 * analyseComplexValue extracts numbers from CSS strings and puts the
 * surrounding text into a `split` template array. For example:
 *   "calc(var(--gap) / 5)"  →  values: [var(--gap), 5]
 *                               split:  ["calc(", " / ", ")"]
 *
 * When building a zero-equivalent for animation, naively zeroing all
 * numbers turns the divisor into 0 → "calc(var(--gap) / 0)" → NaN.
 * We detect this by checking whether the text preceding a number
 * (split[i]) ends with "/" — the CSS calc division operator.
 */ const $143d250b15433a18$var$convertToZero = (value, splitBefore)=>{
    if (typeof value === "number") return splitBefore?.trim().endsWith("/") ? value : 0;
    return $143d250b15433a18$var$convertNumbersToZero(value);
};
function $143d250b15433a18$var$getAnimatableNone(v) {
    const info = $143d250b15433a18$export$b61fc7c44bf646d5(v);
    const transformer = $143d250b15433a18$var$buildTransformer(info);
    return transformer(info.values.map((value, i)=>$143d250b15433a18$var$convertToZero(value, info.split[i])));
}
const $143d250b15433a18$export$83a0e34f1302825b = {
    test: $143d250b15433a18$var$test,
    parse: $143d250b15433a18$var$parseComplexValue,
    createTransformer: $143d250b15433a18$var$createTransformer,
    getAnimatableNone: $143d250b15433a18$var$getAnimatableNone
};





// Adapted from https://gist.github.com/mjackson/5311256
function $d04f5b3b6e381351$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $d04f5b3b6e381351$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $d04f5b3b6e381351$var$hueToRgb(p, q, hue + 1 / 3);
        green = $d04f5b3b6e381351$var$hueToRgb(p, q, hue);
        blue = $d04f5b3b6e381351$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}



function $0e9a811868f4f926$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}



// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $f92ed2da03c10c61$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $f92ed2da03c10c61$var$colorTypes = [
    (0, $7d3c4430d6be76c0$export$834dfc94dde4b3d8),
    (0, $db8f3dc4a1301e8a$export$4e46ac54fc82cf3b),
    (0, $aea83326166976b9$export$810b04175080204c)
];
const $f92ed2da03c10c61$var$getColorType = (v)=>$f92ed2da03c10c61$var$colorTypes.find((type)=>type.test(v));
function $f92ed2da03c10c61$var$asRGBA(color) {
    const type = $f92ed2da03c10c61$var$getColorType(color);
    (0, $1f68be864a33a611$export$491112666e282270)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable");
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $aea83326166976b9$export$810b04175080204c)) // TODO Remove this cast - needed since Motion's stricter typing
    model = (0, $d04f5b3b6e381351$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $f92ed2da03c10c61$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $f92ed2da03c10c61$var$asRGBA(from);
    const toRGBA = $f92ed2da03c10c61$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $0e9a811868f4f926$export$a6f92d4bae65c0f1)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $f92ed2da03c10c61$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $f92ed2da03c10c61$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $f92ed2da03c10c61$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $bb85245f2bb1740c$export$3bb0b4ff1037b8dd)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $db8f3dc4a1301e8a$export$4e46ac54fc82cf3b).transform(blended);
    };
};




const $335f28cb61dbd4bb$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $335f28cb61dbd4bb$export$fed62ccc3fb1a568(origin, target) {
    if ($335f28cb61dbd4bb$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}


function $207840ac7d4ae36b$var$mixNumber(a, b) {
    return (p)=>(0, $bb85245f2bb1740c$export$3bb0b4ff1037b8dd)(a, b, p);
}
function $207840ac7d4ae36b$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $207840ac7d4ae36b$var$mixNumber;
    else if (typeof a === "string") return (0, $021b423722640b5d$export$31f9caa2600b5723)(a) ? (0, $0e9a811868f4f926$export$a6f92d4bae65c0f1) : (0, $1f6a47b5445f6d2e$export$35e9368ef982300f).test(a) ? (0, $f92ed2da03c10c61$export$51e568cf5c039bac) : $207840ac7d4ae36b$export$65516310a87d8205;
    else if (Array.isArray(a)) return $207840ac7d4ae36b$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $1f6a47b5445f6d2e$export$35e9368ef982300f).test(a) ? (0, $f92ed2da03c10c61$export$51e568cf5c039bac) : $207840ac7d4ae36b$export$ebc23b6840c51ba1;
    return 0, $0e9a811868f4f926$export$a6f92d4bae65c0f1;
}
function $207840ac7d4ae36b$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$207840ac7d4ae36b$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $207840ac7d4ae36b$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $207840ac7d4ae36b$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $207840ac7d4ae36b$var$matchOrder(origin, target) {
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = origin.values[originIndex] ?? 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $207840ac7d4ae36b$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $143d250b15433a18$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $143d250b15433a18$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $143d250b15433a18$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $335f28cb61dbd4bb$export$e5a55ae567dd4ac7).has(origin) && !targetStats.values.length || (0, $335f28cb61dbd4bb$export$e5a55ae567dd4ac7).has(target) && !originStats.values.length) return (0, $335f28cb61dbd4bb$export$fed62ccc3fb1a568)(origin, target);
        return (0, $eea2d50cab370107$export$a4627e546088548d)($207840ac7d4ae36b$export$3bbefa2f402845c4($207840ac7d4ae36b$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $1f68be864a33a611$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different");
        return (0, $0e9a811868f4f926$export$a6f92d4bae65c0f1)(origin, target);
    }
};



function $3d8c3dec961e7f45$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $bb85245f2bb1740c$export$3bb0b4ff1037b8dd)(from, to, p);
    const mixer = (0, $207840ac7d4ae36b$export$36ec24672cd098e0)(from);
    return mixer(from, to);
}




const $d1dfda2baa852aa1$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: (keepAlive = true)=>(0, $efc9740269028631$export$2cef06c20297c17d).update(passTimestamp, keepAlive),
        stop: ()=>(0, $efc9740269028631$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $efc9740269028631$export$fff89137e9e818ce).isProcessing ? (0, $efc9740269028631$export$fff89137e9e818ce).timestamp : (0, $ecd2e69909b240c8$export$2da9be4cfdb689b1).now()
    };
};




const $b40fac3c0224a6d6$var$velocitySampleDuration = 5; // ms
function $b40fac3c0224a6d6$export$279c5e002bb29070(resolveValue, t, current) {
    const prevT = Math.max(t - $b40fac3c0224a6d6$var$velocitySampleDuration, 0);
    return (0, $ecc46a4789db2f8b$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}


function $7e7f41f1f90b05ca$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $cb6a5de6c9fd4114$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $b40fac3c0224a6d6$export$279c5e002bb29070)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticeably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $ac0dddeee8fc2c3d$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $ac0dddeee8fc2c3d$var$subdivisionPrecision = 0.0000001;
const $ac0dddeee8fc2c3d$var$subdivisionMaxIterations = 12;
function $ac0dddeee8fc2c3d$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $ac0dddeee8fc2c3d$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $ac0dddeee8fc2c3d$var$subdivisionPrecision && ++i < $ac0dddeee8fc2c3d$var$subdivisionMaxIterations);
    return currentT;
}
function $ac0dddeee8fc2c3d$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $acf123bf92e82acf$export$8793edee2d425525;
    const getTForX = (aX)=>$ac0dddeee8fc2c3d$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $ac0dddeee8fc2c3d$var$calcBezier(getTForX(t), mY1, mY2);
}


const $e915fc1e56cc4a33$export$929e5a82286172a6 = /*@__PURE__*/ (0, $ac0dddeee8fc2c3d$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $e915fc1e56cc4a33$export$57636bb43b1ccbb0 = /*@__PURE__*/ (0, $ac0dddeee8fc2c3d$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $e915fc1e56cc4a33$export$c07234257a03d5e9 = /*@__PURE__*/ (0, $ac0dddeee8fc2c3d$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);




// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $85564d7dfd25ff1d$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $543268710b46f7a5$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $6c3b9a37b124fe11$export$77edfce482316a60 = /*@__PURE__*/ (0, $ac0dddeee8fc2c3d$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $6c3b9a37b124fe11$export$b01116c84cdfe1a2 = /*@__PURE__*/ (0, $543268710b46f7a5$export$2c07eeff45156d4d)($6c3b9a37b124fe11$export$77edfce482316a60);
const $6c3b9a37b124fe11$export$ddc5fd596f6c71b2 = /*@__PURE__*/ (0, $85564d7dfd25ff1d$export$f946554fb8aeaf0d)($6c3b9a37b124fe11$export$b01116c84cdfe1a2);


const $3e8658fb6e2334f0$export$6b0af63b873d419e = (p)=>p >= 1 ? 1 : (p *= 2) < 1 ? 0.5 * (0, $6c3b9a37b124fe11$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));





const $39f6437628be2e54$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $39f6437628be2e54$export$c8d67a19199d1a50 = (0, $543268710b46f7a5$export$2c07eeff45156d4d)($39f6437628be2e54$export$e444123e42d03385);
const $39f6437628be2e54$export$30d3455eee55bed5 = (0, $85564d7dfd25ff1d$export$f946554fb8aeaf0d)($39f6437628be2e54$export$e444123e42d03385);




const $c3022928bbdcab2d$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";


const $ba45346e85a9f5d6$var$easingLookup = {
    linear: (0, $acf123bf92e82acf$export$8793edee2d425525),
    easeIn: $e915fc1e56cc4a33$export$929e5a82286172a6,
    easeInOut: $e915fc1e56cc4a33$export$c07234257a03d5e9,
    easeOut: $e915fc1e56cc4a33$export$57636bb43b1ccbb0,
    circIn: $39f6437628be2e54$export$e444123e42d03385,
    circInOut: $39f6437628be2e54$export$30d3455eee55bed5,
    circOut: $39f6437628be2e54$export$c8d67a19199d1a50,
    backIn: $6c3b9a37b124fe11$export$b01116c84cdfe1a2,
    backInOut: $6c3b9a37b124fe11$export$ddc5fd596f6c71b2,
    backOut: $6c3b9a37b124fe11$export$77edfce482316a60,
    anticipate: $3e8658fb6e2334f0$export$6b0af63b873d419e
};
const $ba45346e85a9f5d6$var$isValidEasing = (easing)=>{
    return typeof easing === "string";
};
const $ba45346e85a9f5d6$export$ef97fe084f156ca4 = (definition)=>{
    if ((0, $c3022928bbdcab2d$export$ff43f99925d7366b)(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $1f68be864a33a611$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`, "cubic-bezier-length");
        const [x1, y1, x2, y2] = definition;
        return (0, $ac0dddeee8fc2c3d$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if ($ba45346e85a9f5d6$var$isValidEasing(definition)) {
        // Else lookup from table
        (0, $1f68be864a33a611$export$f5708dca728d7177)($ba45346e85a9f5d6$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`, "invalid-easing-type");
        return $ba45346e85a9f5d6$var$easingLookup[definition];
    }
    return definition;
};




function $5e2567d4a317a734$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $252c15636d941e6e$export$dd826089e3c5e502).mix || (0, $3d8c3dec961e7f45$export$2c9e8a9632a706b2);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $acf123bf92e82acf$export$8793edee2d425525) : ease;
            mixer = (0, $eea2d50cab370107$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revisit this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $5e2567d4a317a734$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $1f68be864a33a611$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length", "range-length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && output[0] === output[1]) return ()=>output[1];
    const isZeroDeltaRange = input[0] === input[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $5e2567d4a317a734$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        if (isZeroDeltaRange && v < input[0]) return output[0];
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $f5eb66e60bd17fc7$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $d03597240d130486$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}



function $09f86943c4e10819$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $6ecdce0bbf7647e0$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $e915fc1e56cc4a33$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $6ecdce0bbf7647e0$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $6b4f22c3afa23da5$export$216948827bbdc797)(ease) ? ease.map((0, $ba45346e85a9f5d6$export$ef97fe084f156ca4)) : (0, $ba45346e85a9f5d6$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $09f86943c4e10819$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $e40cb325918ea9b6$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $5e2567d4a317a734$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $6ecdce0bbf7647e0$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}




const $5ce76d80640f9c0e$var$isNotNull = (value)=>value !== null;
function $5ce76d80640f9c0e$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe, speed = 1) {
    const resolvedKeyframes = keyframes.filter($5ce76d80640f9c0e$var$isNotNull);
    const useFirstKeyframe = speed < 0 || repeat && repeatType !== "loop" && repeat % 2 === 1;
    const index = useFirstKeyframe ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}





const $48e81b9a28e4feb6$var$transitionTypeMap = {
    decay: (0, $7e7f41f1f90b05ca$export$ee3ff3a17106998),
    inertia: $7e7f41f1f90b05ca$export$ee3ff3a17106998,
    tween: (0, $6ecdce0bbf7647e0$export$d25ddfdf17c3ad3e),
    keyframes: (0, $6ecdce0bbf7647e0$export$d25ddfdf17c3ad3e),
    spring: $cb6a5de6c9fd4114$export$b36281d89752ae66
};
function $48e81b9a28e4feb6$export$98db6ef1242dfa2(transition) {
    if (typeof transition.type === "string") transition.type = $48e81b9a28e4feb6$var$transitionTypeMap[transition.type];
}


class $65512c280adac755$export$655db786091c33e0 {
    constructor(){
        this.updateFinished();
    }
    get finished() {
        return this._finished;
    }
    updateFinished() {
        this._finished = new Promise((resolve)=>{
            this.resolve = resolve;
        });
    }
    notifyFinished() {
        this.resolve();
    }
    /**
     * Allows the animation to be awaited.
     *
     * @deprecated Use `finished` instead.
     */ then(onResolve, onReject) {
        return this.finished.then(onResolve, onReject);
    }
}


const $531a2d1e2b856fae$var$percentToProgress = (percent)=>percent / 100;
class $531a2d1e2b856fae$export$3394f837405475c7 extends (0, $65512c280adac755$export$655db786091c33e0) {
    constructor(options){
        super();
        this.state = "idle";
        this.startTime = null;
        this.isStopped = false;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * Reusable state object for the delay phase to avoid
         * allocating a new object every frame.
         */ this.delayState = {
            done: false,
            value: undefined
        };
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            const { motionValue: motionValue } = this.options;
            if (motionValue && motionValue.updatedAt !== (0, $ecd2e69909b240c8$export$2da9be4cfdb689b1).now()) this.tick((0, $ecd2e69909b240c8$export$2da9be4cfdb689b1).now());
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            this.options.onStop?.();
        };
        (0, $60c98e7bc69ece91$export$d921fb2475e2900c).mainThread++;
        this.options = options;
        this.initAnimation();
        this.play();
        if (options.autoplay === false) this.pause();
    }
    initAnimation() {
        const { options: options } = this;
        (0, $48e81b9a28e4feb6$export$98db6ef1242dfa2)(options);
        const { type: type = (0, $6ecdce0bbf7647e0$export$d25ddfdf17c3ad3e), repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = options;
        let { keyframes: keyframes$1 } = options;
        const generatorFactory = type || (0, $6ecdce0bbf7647e0$export$d25ddfdf17c3ad3e);
        if (generatorFactory !== (0, $6ecdce0bbf7647e0$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
            this.mixKeyframes = (0, $eea2d50cab370107$export$a4627e546088548d)($531a2d1e2b856fae$var$percentToProgress, (0, $3d8c3dec961e7f45$export$2c9e8a9632a706b2)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") this.mirroredGenerator = generatorFactory({
            ...options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $a3d0fc11d0c6bf6e$export$cbdd6b3d40ea54e2)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        this.calculatedDuration = calculatedDuration;
        this.resolvedDuration = calculatedDuration + repeatDelay;
        this.totalDuration = this.resolvedDuration * (repeat + 1) - repeatDelay;
        this.generator = generator;
    }
    updateTime(timestamp) {
        const animationTime = Math.round(timestamp - this.startTime) * this.playbackSpeed;
        // Update currentTime
        if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = animationTime;
    }
    tick(timestamp, sample = false) {
        const { generator: generator, totalDuration: totalDuration, mixKeyframes: mixKeyframes, mirroredGenerator: mirroredGenerator, resolvedDuration: resolvedDuration, calculatedDuration: calculatedDuration } = this;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay = 0, keyframes: keyframes, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, type: type, onUpdate: onUpdate, finalKeyframe: finalKeyframe } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        if (sample) this.currentTime = timestamp;
        else this.updateTime(timestamp);
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.playbackSpeed >= 0 ? 1 : -1);
        const isInDelayPhase = this.playbackSpeed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $d03597240d130486$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ let state;
        if (isInDelayPhase) {
            this.delayState.value = keyframes[0];
            state = this.delayState;
        } else state = frameGenerator.next(elapsed);
        if (mixKeyframes && !isInDelayPhase) state.value = mixKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.playbackSpeed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        // TODO: The exception for inertia could be cleaner here
        if (isAnimationFinished && type !== (0, $7e7f41f1f90b05ca$export$ee3ff3a17106998)) state.value = (0, $5ce76d80640f9c0e$export$14de59408fad90b)(keyframes, this.options, finalKeyframe, this.speed);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.finished.then(resolve, reject);
    }
    get duration() {
        return (0, $c8fe15c475fa19ba$export$f64c3bfbc58eec0f)(this.calculatedDuration);
    }
    get iterationDuration() {
        const { delay: delay = 0 } = this.options || {};
        return this.duration + (0, $c8fe15c475fa19ba$export$f64c3bfbc58eec0f)(delay);
    }
    get time() {
        return (0, $c8fe15c475fa19ba$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $c8fe15c475fa19ba$export$fc3e7e8557f8c8c7)(newTime);
        this.currentTime = newTime;
        if (this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.playbackSpeed;
        if (this.driver) this.driver.start(false);
        else {
            this.startTime = 0;
            this.state = "paused";
            this.holdTime = newTime;
            this.tick(newTime);
        }
    }
    /**
     * Returns the generator's velocity at the current time in units/second.
     * Uses the analytical derivative when available (springs), avoiding
     * the MotionValue's frame-dependent velocity estimation.
     */ getGeneratorVelocity() {
        const t = this.currentTime;
        if (t <= 0) return this.options.velocity || 0;
        if (this.generator.velocity) return this.generator.velocity(t);
        // Fallback: finite difference
        const current = this.generator.next(t).value;
        return (0, $b40fac3c0224a6d6$export$279c5e002bb29070)((s)=>this.generator.next(s).value, t, current);
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        const hasChanged = this.playbackSpeed !== newSpeed;
        if (hasChanged && this.driver) this.updateTime((0, $ecd2e69909b240c8$export$2da9be4cfdb689b1).now());
        this.playbackSpeed = newSpeed;
        if (hasChanged && this.driver) this.time = (0, $c8fe15c475fa19ba$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    play() {
        if (this.isStopped) return;
        const { driver: driver = (0, $d1dfda2baa852aa1$export$c1033964b5ad7fef), startTime: startTime } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        this.options.onPlay?.();
        const now = this.driver.now();
        if (this.state === "finished") {
            this.updateFinished();
            this.startTime = now;
        } else if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime) this.startTime = startTime ?? now;
        if (this.state === "finished" && this.speed < 0) this.startTime += this.calculatedDuration;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        this.state = "paused";
        this.updateTime((0, $ecd2e69909b240c8$export$2da9be4cfdb689b1).now());
        this.holdTime = this.currentTime;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.notifyFinished();
        this.teardown();
        this.state = "finished";
        this.options.onComplete?.();
    }
    cancel() {
        this.holdTime = null;
        this.startTime = 0;
        this.tick(0);
        this.teardown();
        this.options.onCancel?.();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.startTime = this.holdTime = null;
        (0, $60c98e7bc69ece91$export$d921fb2475e2900c).mainThread--;
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(sampleTime) {
        this.startTime = 0;
        return this.tick(sampleTime, true);
    }
    attachTimeline(timeline) {
        if (this.options.allowFlatten) {
            this.options.type = "keyframes";
            this.options.ease = "linear";
            this.initAnimation();
        }
        this.driver?.stop();
        return timeline.observe(this);
    }
}
// Legacy function support
function $531a2d1e2b856fae$export$ee9b76de7353d815(options) {
    return new $531a2d1e2b856fae$export$3394f837405475c7(options);
}



function $051b28c4fda44514$export$5a98a90409277f5a(keyframes) {
    for(let i = 1; i < keyframes.length; i++)keyframes[i] ?? (keyframes[i] = keyframes[i - 1]);
}


const $90e46a0bb3605a3d$var$radToDeg = (rad)=>rad * 180 / Math.PI;
const $90e46a0bb3605a3d$var$rotate = (v)=>{
    const angle = $90e46a0bb3605a3d$var$radToDeg(Math.atan2(v[1], v[0]));
    return $90e46a0bb3605a3d$var$rebaseAngle(angle);
};
const $90e46a0bb3605a3d$var$matrix2dParsers = {
    x: 4,
    y: 5,
    translateX: 4,
    translateY: 5,
    scaleX: 0,
    scaleY: 3,
    scale: (v)=>(Math.abs(v[0]) + Math.abs(v[3])) / 2,
    rotate: $90e46a0bb3605a3d$var$rotate,
    rotateZ: $90e46a0bb3605a3d$var$rotate,
    skewX: (v)=>$90e46a0bb3605a3d$var$radToDeg(Math.atan(v[1])),
    skewY: (v)=>$90e46a0bb3605a3d$var$radToDeg(Math.atan(v[2])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[2])) / 2
};
const $90e46a0bb3605a3d$var$rebaseAngle = (angle)=>{
    angle = angle % 360;
    if (angle < 0) angle += 360;
    return angle;
};
const $90e46a0bb3605a3d$var$rotateZ = $90e46a0bb3605a3d$var$rotate;
const $90e46a0bb3605a3d$var$scaleX = (v)=>Math.sqrt(v[0] * v[0] + v[1] * v[1]);
const $90e46a0bb3605a3d$var$scaleY = (v)=>Math.sqrt(v[4] * v[4] + v[5] * v[5]);
const $90e46a0bb3605a3d$var$matrix3dParsers = {
    x: 12,
    y: 13,
    z: 14,
    translateX: 12,
    translateY: 13,
    translateZ: 14,
    scaleX: $90e46a0bb3605a3d$var$scaleX,
    scaleY: $90e46a0bb3605a3d$var$scaleY,
    scale: (v)=>($90e46a0bb3605a3d$var$scaleX(v) + $90e46a0bb3605a3d$var$scaleY(v)) / 2,
    rotateX: (v)=>$90e46a0bb3605a3d$var$rebaseAngle($90e46a0bb3605a3d$var$radToDeg(Math.atan2(v[6], v[5]))),
    rotateY: (v)=>$90e46a0bb3605a3d$var$rebaseAngle($90e46a0bb3605a3d$var$radToDeg(Math.atan2(-v[2], v[0]))),
    rotateZ: $90e46a0bb3605a3d$var$rotateZ,
    rotate: $90e46a0bb3605a3d$var$rotateZ,
    skewX: (v)=>$90e46a0bb3605a3d$var$radToDeg(Math.atan(v[4])),
    skewY: (v)=>$90e46a0bb3605a3d$var$radToDeg(Math.atan(v[1])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[4])) / 2
};
function $90e46a0bb3605a3d$export$1f10c01143b9f089(name) {
    return name.includes("scale") ? 1 : 0;
}
function $90e46a0bb3605a3d$export$f9111f9e16b73a26(transform, name) {
    if (!transform || transform === "none") return $90e46a0bb3605a3d$export$1f10c01143b9f089(name);
    const matrix3dMatch = transform.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
    let parsers;
    let match;
    if (matrix3dMatch) {
        parsers = $90e46a0bb3605a3d$var$matrix3dParsers;
        match = matrix3dMatch;
    } else {
        const matrix2dMatch = transform.match(/^matrix\(([-\d.e\s,]+)\)$/u);
        parsers = $90e46a0bb3605a3d$var$matrix2dParsers;
        match = matrix2dMatch;
    }
    if (!match) return $90e46a0bb3605a3d$export$1f10c01143b9f089(name);
    const valueParser = parsers[name];
    const values = match[1].split(",").map($90e46a0bb3605a3d$var$convertTransformToNumber);
    return typeof valueParser === "function" ? valueParser(values) : values[valueParser];
}
const $90e46a0bb3605a3d$export$bcd97e0e03ba17f6 = (instance, name)=>{
    const { transform: transform = "none" } = getComputedStyle(instance);
    return $90e46a0bb3605a3d$export$f9111f9e16b73a26(transform, name);
};
function $90e46a0bb3605a3d$var$convertTransformToNumber(value) {
    return parseFloat(value.trim());
}


/**
 * Generate a list of every possible transform key.
 */ const $f2aa2df0b1d5a3cf$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $f2aa2df0b1d5a3cf$export$7b42a0094fb00b6e = /*@__PURE__*/ (()=>new Set($f2aa2df0b1d5a3cf$export$280dc01950909d86))();




const $c8fa35933e0c86f5$export$8e5250d1aa9bf370 = (v)=>v === (0, $a4fcdad035128669$export$98e628dec113755e) || v === (0, $31304987b0919f83$export$91c0eda1d06bf008);
const $c8fa35933e0c86f5$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $c8fa35933e0c86f5$var$nonTranslationalTransformKeys = (0, $f2aa2df0b1d5a3cf$export$280dc01950909d86).filter((key)=>!$c8fa35933e0c86f5$var$transformKeys.has(key));
function $c8fa35933e0c86f5$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $c8fa35933e0c86f5$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $c8fa35933e0c86f5$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0", boxSizing: boxSizing })=>{
        const width = x.max - x.min;
        return boxSizing === "border-box" ? width : width - parseFloat(paddingLeft) - parseFloat(paddingRight);
    },
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0", boxSizing: boxSizing })=>{
        const height = y.max - y.min;
        return boxSizing === "border-box" ? height : height - parseFloat(paddingTop) - parseFloat(paddingBottom);
    },
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: (_bbox, { transform: transform })=>(0, $90e46a0bb3605a3d$export$f9111f9e16b73a26)(transform, "x"),
    y: (_bbox, { transform: transform })=>(0, $90e46a0bb3605a3d$export$f9111f9e16b73a26)(transform, "y")
};
// Alias translate longform names
$c8fa35933e0c86f5$export$781d46a8aa670d52.translateX = $c8fa35933e0c86f5$export$781d46a8aa670d52.x;
$c8fa35933e0c86f5$export$781d46a8aa670d52.translateY = $c8fa35933e0c86f5$export$781d46a8aa670d52.y;



const $01b8590b0c4ca61c$var$toResolve = new Set();
let $01b8590b0c4ca61c$var$isScheduled = false;
let $01b8590b0c4ca61c$var$anyNeedsMeasurement = false;
let $01b8590b0c4ca61c$var$isForced = false;
function $01b8590b0c4ca61c$var$measureAllKeyframes() {
    if ($01b8590b0c4ca61c$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($01b8590b0c4ca61c$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $c8fa35933e0c86f5$export$39d4bc9655f3f632)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                element.getValue(key)?.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $01b8590b0c4ca61c$var$anyNeedsMeasurement = false;
    $01b8590b0c4ca61c$var$isScheduled = false;
    $01b8590b0c4ca61c$var$toResolve.forEach((resolver)=>resolver.complete($01b8590b0c4ca61c$var$isForced));
    $01b8590b0c4ca61c$var$toResolve.clear();
}
function $01b8590b0c4ca61c$var$readAllKeyframes() {
    $01b8590b0c4ca61c$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $01b8590b0c4ca61c$var$anyNeedsMeasurement = true;
    });
}
function $01b8590b0c4ca61c$export$78b96d2a12593b05() {
    $01b8590b0c4ca61c$var$isForced = true;
    $01b8590b0c4ca61c$var$readAllKeyframes();
    $01b8590b0c4ca61c$var$measureAllKeyframes();
    $01b8590b0c4ca61c$var$isForced = false;
}
class $01b8590b0c4ca61c$export$74d34ca3182f1750 {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        this.state = "pending";
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.state = "scheduled";
        if (this.isAsync) {
            $01b8590b0c4ca61c$var$toResolve.add(this);
            if (!$01b8590b0c4ca61c$var$isScheduled) {
                $01b8590b0c4ca61c$var$isScheduled = true;
                (0, $efc9740269028631$export$2cef06c20297c17d).read($01b8590b0c4ca61c$var$readAllKeyframes);
                (0, $efc9740269028631$export$2cef06c20297c17d).resolveKeyframes($01b8590b0c4ca61c$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        // If initial keyframe is null we need to read it from the DOM
        if (unresolvedKeyframes[0] === null) {
            const currentValue = motionValue?.get();
            // TODO: This doesn't work if the final keyframe is a wildcard
            const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
            if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
            else if (element && name) {
                const valueAsRead = element.readValue(name, finalKeyframe);
                if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
            }
            if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
            if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
        }
        (0, $051b28c4fda44514$export$5a98a90409277f5a)(unresolvedKeyframes);
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete(isForcedComplete = false) {
        this.state = "complete";
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, isForcedComplete);
        $01b8590b0c4ca61c$var$toResolve.delete(this);
    }
    cancel() {
        if (this.state === "scheduled") {
            $01b8590b0c4ca61c$var$toResolve.delete(this);
            this.state = "pending";
        }
    }
    resume() {
        if (this.state === "pending") this.scheduleResolve();
    }
}




const $299d026177364a26$export$c9f584638d388483 = (name)=>name.startsWith("--");


function $4bc049cc34ed6c05$export$37a5fde709c1db82(element, name, value) {
    (0, $299d026177364a26$export$c9f584638d388483)(name) ? element.style.setProperty(name, value) : element.style[name] = value;
}





/*#__NO_SIDE_EFFECTS__*/ function $46b66e92d3922f1d$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}


/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */ const $03c66c05d8722d37$export$e3ad02c335474dee = {};


function $ce3e1f2b0d6326a9$export$1964673d5ec13c3a(callback, supportsFlag) {
    const memoized = (0, $46b66e92d3922f1d$export$7c73462e0d25e514)(callback);
    return ()=>(0, $03c66c05d8722d37$export$e3ad02c335474dee)[supportsFlag] ?? memoized();
}


const $a1f95ed2f7a67598$export$20d68f04f30763a5 = /* @__PURE__ */ (0, $ce3e1f2b0d6326a9$export$1964673d5ec13c3a)(()=>window.ScrollTimeline !== undefined, "scrollTimeline");
const $a1f95ed2f7a67598$export$206321d8c5f8fd38 = /* @__PURE__ */ (0, $ce3e1f2b0d6326a9$export$1964673d5ec13c3a)(()=>window.ViewTimeline !== undefined, "viewTimeline");








const $b3bf4dcb0b443853$export$866c1d07a1ac2ab = /*@__PURE__*/ (0, $ce3e1f2b0d6326a9$export$1964673d5ec13c3a)(()=>{
    try {
        document.createElement("div").animate({
            opacity: 0
        }, {
            easing: "linear(0, 1)"
        });
    } catch (e) {
        return false;
    }
    return true;
}, "linearEasing");



const $ae68911241ad32da$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;



const $2b1f4ae5662d4c46$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ (0, $ae68911241ad32da$export$2523b8f0bd8f44cb)([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ (0, $ae68911241ad32da$export$2523b8f0bd8f44cb)([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ (0, $ae68911241ad32da$export$2523b8f0bd8f44cb)([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ (0, $ae68911241ad32da$export$2523b8f0bd8f44cb)([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};


function $18ebcb7a3a4d0d8c$export$916ea73bcd3a6030(easing, duration) {
    if (!easing) return undefined;
    else if (typeof easing === "function") return (0, $b3bf4dcb0b443853$export$866c1d07a1ac2ab)() ? (0, $2cb279345489b9e2$export$66d3851e2b1ec912)(easing, duration) : "ease-out";
    else if ((0, $c3022928bbdcab2d$export$ff43f99925d7366b)(easing)) return (0, $ae68911241ad32da$export$2523b8f0bd8f44cb)(easing);
    else if (Array.isArray(easing)) return easing.map((segmentEasing)=>$18ebcb7a3a4d0d8c$export$916ea73bcd3a6030(segmentEasing, duration) || (0, $2b1f4ae5662d4c46$export$2cf569f5e2221176).easeOut);
    else return (0, $2b1f4ae5662d4c46$export$2cf569f5e2221176)[easing];
}


function $9ada076f6f1ba19d$export$d896de52f97cb615(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease = "easeOut", times: times } = {}, pseudoElement) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $18ebcb7a3a4d0d8c$export$916ea73bcd3a6030)(ease, duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    if ((0, $ea8eaf9a1bafcb0c$export$84ce9a476f53d110).value) (0, $60c98e7bc69ece91$export$d921fb2475e2900c).waapi++;
    const options = {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    };
    if (pseudoElement) options.pseudoElement = pseudoElement;
    const animation = element.animate(keyframeOptions, options);
    if ((0, $ea8eaf9a1bafcb0c$export$84ce9a476f53d110).value) animation.finished.finally(()=>{
        (0, $60c98e7bc69ece91$export$d921fb2475e2900c).waapi--;
    });
    return animation;
}




function $9a32613d4b313f83$export$a31269144d66b4a({ type: type, ...options }) {
    if ((0, $a95a3e57f039e5f3$export$6ab7812f1bac68be)(type) && (0, $b3bf4dcb0b443853$export$866c1d07a1ac2ab)()) return type.applyToOptions(options);
    else {
        options.duration ?? (options.duration = 300);
        options.ease ?? (options.ease = "easeOut");
    }
    return options;
}


/**
 * NativeAnimation implements AnimationPlaybackControls for the browser's Web Animations API.
 */ class $a881d2fd31b5c0fd$export$6c0f9803d8aa7219 extends (0, $65512c280adac755$export$655db786091c33e0) {
    constructor(options){
        super();
        this.finishedTime = null;
        this.isStopped = false;
        /**
         * Tracks a manually-set start time that takes precedence over WAAPI's
         * dynamic startTime. This is cleared when play() or time setter is called,
         * allowing WAAPI to take over timing.
         */ this.manualStartTime = null;
        if (!options) return;
        const { element: element, name: name, keyframes: keyframes, pseudoElement: pseudoElement, allowFlatten: allowFlatten = false, finalKeyframe: finalKeyframe, onComplete: onComplete } = options;
        this.isPseudoElement = Boolean(pseudoElement);
        this.allowFlatten = allowFlatten;
        this.options = options;
        (0, $1f68be864a33a611$export$f5708dca728d7177)(typeof options.type !== "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
        const transition = (0, $9a32613d4b313f83$export$a31269144d66b4a)(options);
        this.animation = (0, $9ada076f6f1ba19d$export$d896de52f97cb615)(element, name, keyframes, transition, pseudoElement);
        if (transition.autoplay === false) this.animation.pause();
        this.animation.onfinish = ()=>{
            this.finishedTime = this.time;
            if (!pseudoElement) {
                const keyframe = (0, $5ce76d80640f9c0e$export$14de59408fad90b)(keyframes, this.options, finalKeyframe, this.speed);
                if (this.updateMotionValue) this.updateMotionValue(keyframe);
                /**
                 * If we can, we want to commit the final style as set by the user,
                 * rather than the computed keyframe value supplied by the animation.
                 * We always do this, even when a motion value is present, to prevent
                 * a visual flash in Firefox where the WAAPI animation's fill is removed
                 * during cancel() before the scheduled render can apply the correct value.
                 */ (0, $4bc049cc34ed6c05$export$37a5fde709c1db82)(element, name, keyframe);
                this.animation.cancel();
            }
            onComplete?.();
            this.notifyFinished();
        };
    }
    play() {
        if (this.isStopped) return;
        this.manualStartTime = null;
        this.animation.play();
        if (this.state === "finished") this.updateFinished();
    }
    pause() {
        this.animation.pause();
    }
    complete() {
        this.animation.finish?.();
    }
    cancel() {
        try {
            this.animation.cancel();
        } catch (e) {}
    }
    stop() {
        if (this.isStopped) return;
        this.isStopped = true;
        const { state: state } = this;
        if (state === "idle" || state === "finished") return;
        if (this.updateMotionValue) this.updateMotionValue();
        else this.commitStyles();
        if (!this.isPseudoElement) this.cancel();
    }
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * In this method, we commit styles back to the DOM before cancelling
     * the animation.
     *
     * This is designed to be overridden by NativeAnimationExtended, which
     * will create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to also correctly calculate velocity for any subsequent animation
     * while deferring the commit until the next animation frame.
     */ commitStyles() {
        const element = this.options?.element;
        if (!this.isPseudoElement && element?.isConnected) this.animation.commitStyles?.();
    }
    get duration() {
        const duration = this.animation.effect?.getComputedTiming?.().duration || 0;
        return (0, $c8fe15c475fa19ba$export$f64c3bfbc58eec0f)(Number(duration));
    }
    get iterationDuration() {
        const { delay: delay = 0 } = this.options || {};
        return this.duration + (0, $c8fe15c475fa19ba$export$f64c3bfbc58eec0f)(delay);
    }
    get time() {
        return (0, $c8fe15c475fa19ba$export$f64c3bfbc58eec0f)(Number(this.animation.currentTime) || 0);
    }
    set time(newTime) {
        const wasFinished = this.finishedTime !== null;
        this.manualStartTime = null;
        this.finishedTime = null;
        this.animation.currentTime = (0, $c8fe15c475fa19ba$export$fc3e7e8557f8c8c7)(newTime);
        if (wasFinished) this.animation.pause();
    }
    /**
     * The playback speed of the animation.
     * 1 = normal speed, 2 = double speed, 0.5 = half speed.
     */ get speed() {
        return this.animation.playbackRate;
    }
    set speed(newSpeed) {
        // Allow backwards playback after finishing
        if (newSpeed < 0) this.finishedTime = null;
        this.animation.playbackRate = newSpeed;
    }
    get state() {
        return this.finishedTime !== null ? "finished" : this.animation.playState;
    }
    get startTime() {
        return this.manualStartTime ?? Number(this.animation.startTime);
    }
    set startTime(newStartTime) {
        this.manualStartTime = this.animation.startTime = newStartTime;
    }
    /**
     * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
     */ attachTimeline({ timeline: timeline, rangeStart: rangeStart, rangeEnd: rangeEnd, observe: observe }) {
        if (this.allowFlatten) this.animation.effect?.updateTiming({
            easing: "linear"
        });
        this.animation.onfinish = null;
        if (timeline && (0, $a1f95ed2f7a67598$export$20d68f04f30763a5)()) {
            this.animation.timeline = timeline;
            if (rangeStart) this.animation.rangeStart = rangeStart;
            if (rangeEnd) this.animation.rangeEnd = rangeEnd;
            return 0, $acf123bf92e82acf$export$8793edee2d425525;
        } else return observe(this);
    }
}




const $cbfcb730e83a0360$var$unsupportedEasingFunctions = {
    anticipate: $3e8658fb6e2334f0$export$6b0af63b873d419e,
    backInOut: $6c3b9a37b124fe11$export$ddc5fd596f6c71b2,
    circInOut: $39f6437628be2e54$export$30d3455eee55bed5
};
function $cbfcb730e83a0360$var$isUnsupportedEase(key) {
    return key in $cbfcb730e83a0360$var$unsupportedEasingFunctions;
}
function $cbfcb730e83a0360$export$5195f232c29d1f82(transition) {
    if (typeof transition.ease === "string" && $cbfcb730e83a0360$var$isUnsupportedEase(transition.ease)) transition.ease = $cbfcb730e83a0360$var$unsupportedEasingFunctions[transition.ease];
}


/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $6ad4be525f12d88e$var$sampleDelta = 10; //ms
class $6ad4be525f12d88e$export$bd2cd6a048093d96 extends (0, $a881d2fd31b5c0fd$export$6c0f9803d8aa7219) {
    constructor(options){
        /**
         * The base NativeAnimation function only supports a subset
         * of Motion easings, and WAAPI also only supports some
         * easing functions via string/cubic-bezier definitions.
         *
         * This function replaces those unsupported easing functions
         * with a JS easing function. This will later get compiled
         * to a linear() easing function.
         */ (0, $cbfcb730e83a0360$export$5195f232c29d1f82)(options);
        /**
         * Ensure we replace the transition type with a generator function
         * before passing to WAAPI.
         *
         * TODO: Does this have a better home? It could be shared with
         * JSAnimation.
         */ (0, $48e81b9a28e4feb6$export$98db6ef1242dfa2)(options);
        super(options);
        /**
         * Only set startTime when the animation should autoplay.
         * Setting startTime on a paused WAAPI animation unpauses it
         * (per the WAAPI spec), which breaks autoplay: false.
         */ if (options.startTime !== undefined && options.autoplay !== false) this.startTime = options.startTime;
        this.options = options;
    }
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * Rather than read committed styles back out of the DOM, we can
     * create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to calculate velocity for any subsequent animation.
     */ updateMotionValue(value) {
        const { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, element: element, ...options } = this.options;
        if (!motionValue) return;
        if (value !== undefined) {
            motionValue.set(value);
            return;
        }
        const sampleAnimation = new (0, $531a2d1e2b856fae$export$3394f837405475c7)({
            ...options,
            autoplay: false
        });
        /**
         * Use wall-clock elapsed time for sampling.
         * Under CPU load, WAAPI's currentTime may not reflect actual
         * elapsed time, causing incorrect sampling and visual jumps.
         */ const sampleTime = Math.max($6ad4be525f12d88e$var$sampleDelta, (0, $ecd2e69909b240c8$export$2da9be4cfdb689b1).now() - this.startTime);
        const delta = (0, $d03597240d130486$export$7d15b64cf5a3a4c4)(0, $6ad4be525f12d88e$var$sampleDelta, sampleTime - $6ad4be525f12d88e$var$sampleDelta);
        const current = sampleAnimation.sample(sampleTime).value;
        /**
         * Write the estimated value to inline style so it persists
         * after cancel(), covering the async gap before the next
         * animation starts.
         */ const { name: name } = this.options;
        if (element && name) (0, $4bc049cc34ed6c05$export$37a5fde709c1db82)(element, name, current);
        motionValue.setWithVelocity(sampleAnimation.sample(Math.max(0, sampleTime - delta)).value, current, delta);
        sampleAnimation.stop();
    }
}





/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $ff4712e95565decb$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys that might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $143d250b15433a18$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};


function $03adbce0848c58c2$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $03adbce0848c58c2$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $ff4712e95565decb$export$65676b58b122bc38)(originKeyframe, name);
    const isTargetAnimatable = (0, $ff4712e95565decb$export$65676b58b122bc38)(targetKeyframe, name);
    (0, $1f68be864a33a611$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". "${isOriginAnimatable ? targetKeyframe : originKeyframe}" is not an animatable value.`, "value-not-animatable");
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $03adbce0848c58c2$var$hasKeyframesChanged(keyframes) || (type === "spring" || (0, $a95a3e57f039e5f3$export$6ab7812f1bac68be)(type)) && velocity;
}


function $49745f2d5da9f435$export$b2585dd3c345da47(options) {
    options.duration = 0;
    options.type = "keyframes";
}




/**
 * A list of values that can be hardware-accelerated.
 */ const $901b1d16861d60af$export$a27eefbd8fb5e404 = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);


const $bd7431b9fa5e2e9b$var$browserColorFunctions = /^(?:oklch|oklab|lab|lch|color|color-mix|light-dark)\(/;
function $bd7431b9fa5e2e9b$export$1af9e65d1501d15(keyframes) {
    for(let i = 0; i < keyframes.length; i++){
        if (typeof keyframes[i] === "string" && $bd7431b9fa5e2e9b$var$browserColorFunctions.test(keyframes[i])) return true;
    }
    return false;
}


const $1de1ddd7a9bf43ea$var$colorProperties = new Set([
    "color",
    "backgroundColor",
    "outlineColor",
    "fill",
    "stroke",
    "borderColor",
    "borderTopColor",
    "borderRightColor",
    "borderBottomColor",
    "borderLeftColor"
]);
const $1de1ddd7a9bf43ea$var$supportsWaapi = /*@__PURE__*/ (0, $46b66e92d3922f1d$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
function $1de1ddd7a9bf43ea$export$ea92bde116fda821(options) {
    const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type, keyframes: keyframes } = options;
    const subject = motionValue?.owner?.current;
    /**
     * We use this check instead of isHTMLElement() because we explicitly
     * **don't** want elements in different timing contexts (i.e. popups)
     * to be accelerated, as it's not possible to sync these animations
     * properly with those driven from the main window frameloop.
     */ if (!(subject instanceof HTMLElement)) return false;
    const { onUpdate: onUpdate, transformTemplate: transformTemplate } = motionValue.owner.getProps();
    return $1de1ddd7a9bf43ea$var$supportsWaapi() && name && /**
         * Force WAAPI for color properties with browser-only color formats
         * (oklch, oklab, lab, lch, etc.) that the JS animation path can't parse.
         */ ((0, $901b1d16861d60af$export$a27eefbd8fb5e404).has(name) || $1de1ddd7a9bf43ea$var$colorProperties.has(name) && (0, $bd7431b9fa5e2e9b$export$1af9e65d1501d15)(keyframes)) && (name !== "transform" || !transformTemplate) && /**
         * If we're outputting values to onUpdate then we can't use WAAPI as there's
         * no way to read the value from WAAPI every frame.
         */ !onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
}


/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ const $4e3e508224513141$var$MAX_RESOLVE_DELAY = 40;
class $4e3e508224513141$export$b9855e2a7dee3dd2 extends (0, $65512c280adac755$export$655db786091c33e0) {
    constructor({ autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", keyframes: keyframes, name: name, motionValue: motionValue, element: element, ...options }){
        super();
        /**
         * Bound to support return animation.stop pattern
         */ this.stop = ()=>{
            if (this._animation) {
                this._animation.stop();
                this.stopTimeline?.();
            }
            this.keyframeResolver?.cancel();
        };
        this.createdAt = (0, $ecd2e69909b240c8$export$2da9be4cfdb689b1).now();
        const optionsWithDefaults = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            name: name,
            motionValue: motionValue,
            element: element,
            ...options
        };
        const KeyframeResolver$1 = element?.KeyframeResolver || (0, $01b8590b0c4ca61c$export$74d34ca3182f1750);
        this.keyframeResolver = new KeyframeResolver$1(keyframes, (resolvedKeyframes, finalKeyframe, forced)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe, optionsWithDefaults, !forced), name, motionValue, element);
        this.keyframeResolver?.scheduleResolve();
    }
    onKeyframesResolved(keyframes, finalKeyframe, options, sync) {
        this.keyframeResolver = undefined;
        const { name: name, type: type, velocity: velocity, delay: delay, isHandoff: isHandoff, onUpdate: onUpdate } = options;
        this.resolvedAt = (0, $ecd2e69909b240c8$export$2da9be4cfdb689b1).now();
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ let canAnimateValue = true;
        if (!(0, $03adbce0848c58c2$export$1b109e6c9968df4f)(keyframes, name, type, velocity)) {
            canAnimateValue = false;
            if ((0, $252c15636d941e6e$export$dd826089e3c5e502).instantAnimations || !delay) onUpdate?.((0, $5ce76d80640f9c0e$export$14de59408fad90b)(keyframes, options, finalKeyframe));
            keyframes[0] = keyframes[keyframes.length - 1];
            (0, $49745f2d5da9f435$export$b2585dd3c345da47)(options);
            options.repeat = 0;
        }
        /**
         * Resolve startTime for the animation.
         *
         * This method uses the createdAt and resolvedAt to calculate the
         * animation startTime. *Ideally*, we would use the createdAt time as t=0
         * as the following frame would then be the first frame of the animation in
         * progress, which would feel snappier.
         *
         * However, if there's a delay (main thread work) between the creation of
         * the animation and the first committed frame, we prefer to use resolvedAt
         * to avoid a sudden jump into the animation.
         */ const startTime = sync ? !this.resolvedAt ? this.createdAt : this.resolvedAt - this.createdAt > $4e3e508224513141$var$MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt : undefined;
        const resolvedOptions = {
            startTime: startTime,
            finalKeyframe: finalKeyframe,
            ...options,
            keyframes: keyframes
        };
        /**
         * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
         * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
         * optimised animation.
         *
         * Also skip WAAPI when keyframes aren't animatable, as the resolved
         * values may not be valid CSS and would trigger browser warnings.
         */ const useWaapi = canAnimateValue && !isHandoff && (0, $1de1ddd7a9bf43ea$export$ea92bde116fda821)(resolvedOptions);
        const element = resolvedOptions.motionValue?.owner?.current;
        let animation;
        if (useWaapi) try {
            animation = new (0, $6ad4be525f12d88e$export$bd2cd6a048093d96)({
                ...resolvedOptions,
                element: element
            });
        } catch  {
            animation = new (0, $531a2d1e2b856fae$export$3394f837405475c7)(resolvedOptions);
        }
        else animation = new (0, $531a2d1e2b856fae$export$3394f837405475c7)(resolvedOptions);
        animation.finished.then(()=>{
            this.notifyFinished();
        }).catch((0, $acf123bf92e82acf$export$8793edee2d425525));
        if (this.pendingTimeline) {
            this.stopTimeline = animation.attachTimeline(this.pendingTimeline);
            this.pendingTimeline = undefined;
        }
        this._animation = animation;
    }
    get finished() {
        if (!this._animation) return this._finished;
        else return this.animation.finished;
    }
    then(onResolve, _onReject) {
        return this.finished.finally(onResolve).then(()=>{});
    }
    get animation() {
        if (!this._animation) {
            this.keyframeResolver?.resume();
            (0, $01b8590b0c4ca61c$export$78b96d2a12593b05)();
        }
        return this._animation;
    }
    get duration() {
        return this.animation.duration;
    }
    get iterationDuration() {
        return this.animation.iterationDuration;
    }
    get time() {
        return this.animation.time;
    }
    set time(newTime) {
        this.animation.time = newTime;
    }
    get speed() {
        return this.animation.speed;
    }
    get state() {
        return this.animation.state;
    }
    set speed(newSpeed) {
        this.animation.speed = newSpeed;
    }
    get startTime() {
        return this.animation.startTime;
    }
    attachTimeline(timeline) {
        if (this._animation) this.stopTimeline = this.animation.attachTimeline(timeline);
        else this.pendingTimeline = timeline;
        return ()=>this.stop();
    }
    play() {
        this.animation.play();
    }
    pause() {
        this.animation.pause();
    }
    complete() {
        this.animation.complete();
    }
    cancel() {
        if (this._animation) this.animation.cancel();
        this.keyframeResolver?.cancel();
    }
}



/**
 * If `transition` has `inherit: true`, shallow-merge it with
 * `parentTransition` (child keys win) and strip the `inherit` key.
 * Otherwise return `transition` unchanged.
 */ function $c8f829da53db5dd6$export$b180037f8f468d61(transition, parentTransition) {
    if (transition?.inherit && parentTransition) {
        const { inherit: _, ...rest } = transition;
        return {
            ...parentTransition,
            ...rest
        };
    }
    return transition;
}


function $a58e6fc4307964be$export$7c1391340308742e(transition, key) {
    const valueTransition = transition?.[key] ?? transition?.["default"] ?? transition;
    if (valueTransition !== transition) return (0, $c8f829da53db5dd6$export$b180037f8f468d61)(valueTransition, transition);
    return valueTransition;
}




const $ceb6e046eb4d999f$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $ceb6e046eb4d999f$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $ceb6e046eb4d999f$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $ceb6e046eb4d999f$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $ceb6e046eb4d999f$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $ceb6e046eb4d999f$var$keyframesTransition;
    else if ((0, $f2aa2df0b1d5a3cf$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $ceb6e046eb4d999f$var$criticallyDampedSpring(keyframes[1]) : $ceb6e046eb4d999f$var$underDampedSpring;
    return $ceb6e046eb4d999f$var$ease;
};



const $25a1075b05496f3f$var$orchestrationKeys = new Set([
    "when",
    "delay",
    "delayChildren",
    "staggerChildren",
    "staggerDirection",
    "repeat",
    "repeatType",
    "repeatDelay",
    "from",
    "elapsed"
]);
/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $25a1075b05496f3f$export$ca8e47dc8ed5a9d7(transition) {
    for(const key in transition){
        if (!$25a1075b05496f3f$var$orchestrationKeys.has(key)) return true;
    }
    return false;
}



const $22d357d8e9e9a93e$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff)=>(onComplete)=>{
        const valueTransition = (0, $a58e6fc4307964be$export$7c1391340308742e)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $c8fe15c475fa19ba$export$fc3e7e8557f8c8c7)(delay);
        const options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unique transition settings for this value.
     */ if (!(0, $25a1075b05496f3f$export$ca8e47dc8ed5a9d7)(valueTransition)) Object.assign(options, (0, $ceb6e046eb4d999f$export$262124b154b9f1c0)(name, options));
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ options.duration && (options.duration = (0, $c8fe15c475fa19ba$export$fc3e7e8557f8c8c7)(options.duration));
        options.repeatDelay && (options.repeatDelay = (0, $c8fe15c475fa19ba$export$fc3e7e8557f8c8c7)(options.repeatDelay));
        /**
     * Support deprecated way to set initial value. Prefer keyframe syntax.
     */ if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            (0, $49745f2d5da9f435$export$b2585dd3c345da47)(options);
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $252c15636d941e6e$export$dd826089e3c5e502).instantAnimations || (0, $252c15636d941e6e$export$dd826089e3c5e502).skipAnimations || element?.shouldSkipAnimations) {
            shouldSkip = true;
            (0, $49745f2d5da9f435$export$b2585dd3c345da47)(options);
            options.delay = 0;
        }
        /**
     * If the transition type or easing has been explicitly set by the user
     * then we don't want to allow flattening the animation.
     */ options.allowFlatten = !valueTransition.type && !valueTransition.ease;
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $5ce76d80640f9c0e$export$14de59408fad90b)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $efc9740269028631$export$2cef06c20297c17d).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                return;
            }
        }
        return valueTransition.isSync ? new (0, $531a2d1e2b856fae$export$3394f837405475c7)(options) : new (0, $4e3e508224513141$export$b9855e2a7dee3dd2)(options);
    };




function $1cbdbcafdf460253$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $332ca6f8f18741ec$export$605d60a2578142d3)(value) ? value : (0, $a82ff1c7e83e3798$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $22d357d8e9e9a93e$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}




const $531dcc0d46ea26ad$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    ...(0, $f2aa2df0b1d5a3cf$export$280dc01950909d86)
]);



function $3fcb84f0549ccfed$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement?.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $3fcb84f0549ccfed$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $3fcb84f0549ccfed$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $3fcb84f0549ccfed$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}


function $7b780befd351f8c9$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $3fcb84f0549ccfed$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}


const $efedf31f9ec7b1b2$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $076e685b148d2fbd$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $a82ff1c7e83e3798$export$ce8bdc721e76545f)(value));
}
function $076e685b148d2fbd$var$resolveFinalValueInKeyframes(v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $efedf31f9ec7b1b2$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
}
function $076e685b148d2fbd$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $7b780befd351f8c9$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = $076e685b148d2fbd$var$resolveFinalValueInKeyframes(target[key]);
        $076e685b148d2fbd$var$setMotionValue(visualElement, key, value);
    }
}




function $6811d4237ccf294e$export$98397f3adbf6259f(value) {
    return Boolean((0, $332ca6f8f18741ec$export$605d60a2578142d3)(value) && value.add);
}


function $b01f17e6edcb0e4e$export$3ac5aed310be0bee(visualElement, key) {
    const willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $6811d4237ccf294e$export$98397f3adbf6259f)(willChange)) return willChange.add(key);
    else if (!willChange && (0, $252c15636d941e6e$export$dd826089e3c5e502).WillChange) {
        const newWillChange = new (0, $252c15636d941e6e$export$dd826089e3c5e502).WillChange("auto");
        visualElement.addValue("willChange", newWillChange);
        newWillChange.add(key);
    }
}


function $d3d0fe356277c935$export$9fd24a634729c672(str) {
    return str.replace(/([A-Z])/g, (match)=>`-${match.toLowerCase()}`);
}


const $1db006ae2fadc946$export$ed7b8fa9dbf0105d = "framerAppearId";
const $1db006ae2fadc946$export$8592e1c077c890a6 = "data-" + (0, $d3d0fe356277c935$export$9fd24a634729c672)($1db006ae2fadc946$export$ed7b8fa9dbf0105d);


function $cdfeb85251edd370$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.props[0, $1db006ae2fadc946$export$8592e1c077c890a6];
}




/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $41f382a3711b7d58$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $41f382a3711b7d58$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    let { transition: transition, transitionEnd: transitionEnd, ...target } = targetAndTransition;
    const defaultTransition = visualElement.getDefaultTransition();
    transition = transition ? (0, $c8f829da53db5dd6$export$b180037f8f468d61)(transition, defaultTransition) : defaultTransition;
    const reduceMotion = transition?.reduceMotion;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, visualElement.latestValues[key] ?? null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $41f382a3711b7d58$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            ...(0, $a58e6fc4307964be$export$7c1391340308742e)(transition || {}, key)
        };
        /**
         * If the value is already at the defined target, skip the animation.
         * We still re-assert the value via frame.update to take precedence
         * over any stale transitionEnd callbacks from previous animations.
         */ const currentValue = value.get();
        if (currentValue !== undefined && !value.isAnimating() && !Array.isArray(valueTarget) && valueTarget === currentValue && !valueTransition.velocity) {
            (0, $efc9740269028631$export$2cef06c20297c17d).update(()=>value.set(valueTarget));
            continue;
        }
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = (0, $cdfeb85251edd370$export$5f8d21e84d1d84fc)(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, (0, $efc9740269028631$export$2cef06c20297c17d));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        (0, $b01f17e6edcb0e4e$export$3ac5aed310be0bee)(visualElement, key);
        const shouldReduceMotion = reduceMotion ?? visualElement.shouldReduceMotion;
        value.start((0, $22d357d8e9e9a93e$export$90b3dfc33ff3548)(key, value, valueTarget, shouldReduceMotion && (0, $531dcc0d46ea26ad$export$c66c0d5db2a205d).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) {
        const applyTransitionEnd = ()=>(0, $efc9740269028631$export$2cef06c20297c17d).update(()=>{
                transitionEnd && (0, $076e685b148d2fbd$export$1f61c53461aff4a5)(visualElement, transitionEnd);
            });
        if (animations.length) Promise.all(animations).then(applyTransitionEnd);
        else applyTransitionEnd();
    }
    return animations;
}

const $e8291a1f6a2194c5$export$bc2a978a17abfdde = new WeakMap();






/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $3a019058be2a1529$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $3a019058be2a1529$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $3a019058be2a1529$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $707db01fab6c415b$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $707db01fab6c415b$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$707db01fab6c415b$var$isIdentityScale(scale) || !$707db01fab6c415b$var$isIdentityScale(scaleX) || !$707db01fab6c415b$var$isIdentityScale(scaleY);
}
function $707db01fab6c415b$export$a545127cf1fbb600(values) {
    return $707db01fab6c415b$export$bdf30dca883ea463(values) || $707db01fab6c415b$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $707db01fab6c415b$export$bf80f5f8f4dc327f(values) {
    return $707db01fab6c415b$var$is2DTranslate(values.x) || $707db01fab6c415b$var$is2DTranslate(values.y);
}
function $707db01fab6c415b$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $2520c21446e69e75$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $2520c21446e69e75$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $2520c21446e69e75$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $2520c21446e69e75$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $2520c21446e69e75$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $2520c21446e69e75$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $2520c21446e69e75$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $2520c21446e69e75$export$d80074982803af5c(box, { x: x, y: y }) {
    $2520c21446e69e75$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $2520c21446e69e75$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
const $2520c21446e69e75$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
const $2520c21446e69e75$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $2520c21446e69e75$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement: visualElement } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) {
            $2520c21446e69e75$export$a807a5ce5ebb3895(box.x, -node.scroll.offset.x);
            $2520c21446e69e75$export$a807a5ce5ebb3895(box.y, -node.scroll.offset.y);
        }
        if (delta) {
            // Incoporate each ancestor's scale into a cumulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $2520c21446e69e75$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $707db01fab6c415b$export$a545127cf1fbb600)(node.latestValues)) $2520c21446e69e75$export$58b16271041fbfb(box, node.latestValues, node.layout?.layoutBox);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $2520c21446e69e75$var$TREE_SCALE_SNAP_MAX && treeScale.x > $2520c21446e69e75$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $2520c21446e69e75$var$TREE_SCALE_SNAP_MAX && treeScale.y > $2520c21446e69e75$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $2520c21446e69e75$export$a807a5ce5ebb3895(axis, distance) {
    axis.min += distance;
    axis.max += distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $2520c21446e69e75$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, $bb85245f2bb1740c$export$3bb0b4ff1037b8dd)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $2520c21446e69e75$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
function $2520c21446e69e75$var$resolveAxisTranslate(value, axis) {
    if (typeof value === "string") return parseFloat(value) / 100 * (axis.max - axis.min);
    return value;
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $2520c21446e69e75$export$58b16271041fbfb(box, transform, sourceBox) {
    const resolveBox = sourceBox ?? box;
    $2520c21446e69e75$export$625f1dd140a2f5e7(box.x, $2520c21446e69e75$var$resolveAxisTranslate(transform.x, resolveBox.x), transform.scaleX, transform.scale, transform.originX);
    $2520c21446e69e75$export$625f1dd140a2f5e7(box.y, $2520c21446e69e75$var$resolveAxisTranslate(transform.y, resolveBox.y), transform.scaleY, transform.scale, transform.originY);
}


function $583c68faadf0bf08$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $3a019058be2a1529$export$d3955c6a8f65a36b)((0, $3a019058be2a1529$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $583c68faadf0bf08$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $583c68faadf0bf08$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $2520c21446e69e75$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $2520c21446e69e75$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}




/**
 * ValueType for "auto"
 */ const $dd07a71c89af4eea$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};




/**
 * Tests a provided value against a ValueType
 */ const $55427f8648eeb04f$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * A list of value types commonly used for dimensions
 */ const $ef4dc8f9eec60b86$export$d176691c1998a1f5 = [
    (0, $a4fcdad035128669$export$98e628dec113755e),
    (0, $31304987b0919f83$export$91c0eda1d06bf008),
    (0, $31304987b0919f83$export$626336c2cd4b14de),
    (0, $31304987b0919f83$export$41fc368e1a942b97),
    (0, $31304987b0919f83$export$aed3d7b7d206c196),
    (0, $31304987b0919f83$export$f91e8c45a95a32f2),
    (0, $dd07a71c89af4eea$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $ef4dc8f9eec60b86$export$eefdd52e3ccae428 = (v)=>$ef4dc8f9eec60b86$export$d176691c1998a1f5.find((0, $55427f8648eeb04f$export$6eae4d0a6a7ca7cd)(v));


/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $5dc4007ec56ff86d$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);



/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $4978a1d5e7348a86$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $4978a1d5e7348a86$export$b9f0c1f373aee2b0(current) {
    const match = $4978a1d5e7348a86$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 ?? token2}`,
        fallback
    ];
}
const $4978a1d5e7348a86$var$maxDepth = 4;
function $4978a1d5e7348a86$export$289398774300c991(current, element, depth = 1) {
    (0, $1f68be864a33a611$export$f5708dca728d7177)(depth <= $4978a1d5e7348a86$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
    const [token, fallback] = $4978a1d5e7348a86$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $5dc4007ec56ff86d$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $021b423722640b5d$export$31f9caa2600b5723)(fallback) ? $4978a1d5e7348a86$export$289398774300c991(fallback, element, depth + 1) : fallback;
}




/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $4efb885de8ac2039$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);


function $02b151aea0fdaf6c$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $4efb885de8ac2039$export$ade84c85e44a6cb1)(value);
    else return true;
}






/**
 * Properties that should default to 1 or 100%
 */ const $c54deb7309a9975d$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $c54deb7309a9975d$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $15219eed37aadc82$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $c54deb7309a9975d$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $c54deb7309a9975d$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $c54deb7309a9975d$export$3dea766d36a8935f = {
    ...(0, $143d250b15433a18$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($c54deb7309a9975d$var$functionRegex);
        return functions ? functions.map($c54deb7309a9975d$var$applyDefaultFilter).join(" ") : v;
    }
};



const $d802a38ab62d94de$export$d99f0801a68bbcf1 = {
    ...(0, $143d250b15433a18$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const parsed = (0, $143d250b15433a18$export$83a0e34f1302825b).parse(v);
        const transformer = (0, $143d250b15433a18$export$83a0e34f1302825b).createTransformer(v);
        return transformer(parsed.map((v)=>typeof v === "number" ? 0 : typeof v === "object" ? {
                ...v,
                alpha: 1
            } : v));
    }
};






const $795cbe24a3c8e826$export$7d260a2a5f8bc19e = {
    ...(0, $a4fcdad035128669$export$98e628dec113755e),
    transform: Math.round
};






const $32b24613c7c0baa5$export$f2e4285fee37e26 = {
    rotate: (0, $31304987b0919f83$export$41fc368e1a942b97),
    rotateX: (0, $31304987b0919f83$export$41fc368e1a942b97),
    rotateY: (0, $31304987b0919f83$export$41fc368e1a942b97),
    rotateZ: (0, $31304987b0919f83$export$41fc368e1a942b97),
    scale: $a4fcdad035128669$export$dcdf75081b88279d,
    scaleX: (0, $a4fcdad035128669$export$dcdf75081b88279d),
    scaleY: (0, $a4fcdad035128669$export$dcdf75081b88279d),
    scaleZ: (0, $a4fcdad035128669$export$dcdf75081b88279d),
    skew: (0, $31304987b0919f83$export$41fc368e1a942b97),
    skewX: (0, $31304987b0919f83$export$41fc368e1a942b97),
    skewY: (0, $31304987b0919f83$export$41fc368e1a942b97),
    distance: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    translateX: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    translateY: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    translateZ: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    x: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    y: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    z: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    perspective: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    transformPerspective: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    opacity: (0, $a4fcdad035128669$export$58f0f39f63f3cf42),
    originX: (0, $31304987b0919f83$export$44e2e1705876d7ed),
    originY: (0, $31304987b0919f83$export$44e2e1705876d7ed),
    originZ: (0, $31304987b0919f83$export$91c0eda1d06bf008)
};


const $d5720b77a1a581e4$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    borderTopWidth: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    borderRightWidth: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    borderRadius: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    maxWidth: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    height: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    maxHeight: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    top: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    right: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    bottom: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    left: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    inset: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    insetBlock: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    insetBlockStart: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    insetBlockEnd: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    insetInline: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    insetInlineStart: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    insetInlineEnd: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    paddingTop: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    paddingRight: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    paddingBottom: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    paddingLeft: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    paddingBlock: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    paddingBlockStart: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    paddingBlockEnd: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    paddingInline: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    paddingInlineStart: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    paddingInlineEnd: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    margin: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    marginTop: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    marginRight: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    marginBottom: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    marginLeft: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    marginBlock: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    marginBlockStart: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    marginBlockEnd: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    marginInline: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    marginInlineStart: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    marginInlineEnd: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    // Typography
    fontSize: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    // Misc
    backgroundPositionX: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    backgroundPositionY: (0, $31304987b0919f83$export$91c0eda1d06bf008),
    ...(0, $32b24613c7c0baa5$export$f2e4285fee37e26),
    zIndex: (0, $795cbe24a3c8e826$export$7d260a2a5f8bc19e),
    // SVG
    fillOpacity: (0, $a4fcdad035128669$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $a4fcdad035128669$export$58f0f39f63f3cf42),
    numOctaves: (0, $795cbe24a3c8e826$export$7d260a2a5f8bc19e)
};


/**
 * A map of default value types for common values
 */ const $095fe303cfb39d3a$export$98cd7c72c5a731fb = {
    ...(0, $d5720b77a1a581e4$export$eec14432cd1cb67b),
    color: // Color props
    $1f6a47b5445f6d2e$export$35e9368ef982300f,
    backgroundColor: (0, $1f6a47b5445f6d2e$export$35e9368ef982300f),
    outlineColor: (0, $1f6a47b5445f6d2e$export$35e9368ef982300f),
    fill: (0, $1f6a47b5445f6d2e$export$35e9368ef982300f),
    stroke: (0, $1f6a47b5445f6d2e$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $1f6a47b5445f6d2e$export$35e9368ef982300f),
    borderTopColor: (0, $1f6a47b5445f6d2e$export$35e9368ef982300f),
    borderRightColor: (0, $1f6a47b5445f6d2e$export$35e9368ef982300f),
    borderBottomColor: (0, $1f6a47b5445f6d2e$export$35e9368ef982300f),
    borderLeftColor: (0, $1f6a47b5445f6d2e$export$35e9368ef982300f),
    filter: $c54deb7309a9975d$export$3dea766d36a8935f,
    WebkitFilter: (0, $c54deb7309a9975d$export$3dea766d36a8935f),
    mask: $d802a38ab62d94de$export$d99f0801a68bbcf1,
    WebkitMask: (0, $d802a38ab62d94de$export$d99f0801a68bbcf1)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $095fe303cfb39d3a$export$67d1babe0338d23b = (key)=>$095fe303cfb39d3a$export$98cd7c72c5a731fb[key];


const $f90b116ea26db880$var$customTypes = /*@__PURE__*/ new Set([
    (0, $c54deb7309a9975d$export$3dea766d36a8935f),
    (0, $d802a38ab62d94de$export$d99f0801a68bbcf1)
]);
function $f90b116ea26db880$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $095fe303cfb39d3a$export$67d1babe0338d23b)(key);
    if (!$f90b116ea26db880$var$customTypes.has(defaultValueType)) defaultValueType = (0, $143d250b15433a18$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}


/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $242d3088abfa675c$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $242d3088abfa675c$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$242d3088abfa675c$var$invalidTemplates.has(keyframe) && (0, $143d250b15433a18$export$b61fc7c44bf646d5)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $f90b116ea26db880$export$cea0cedcb94873b5)(name, animatableTemplate);
}



class $4a3a585a2298ee2a$export$4983792d11b61017 extends (0, $01b8590b0c4ca61c$export$74d34ca3182f1750) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element){
        super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element || !element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $021b423722640b5d$export$31f9caa2600b5723)(keyframe)) {
                    const resolved = (0, $4978a1d5e7348a86$export$289398774300c991)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $531dcc0d46ea26ad$export$c66c0d5db2a205d).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $ef4dc8f9eec60b86$export$eefdd52e3ccae428)(origin);
        const targetType = (0, $ef4dc8f9eec60b86$export$eefdd52e3ccae428)(target);
        /**
         * If one keyframe contains embedded CSS variables (e.g. in calc()) and the other
         * doesn't, we need to measure to convert to pixels. This handles GitHub issue #3410.
         */ const originHasVar = (0, $021b423722640b5d$export$df8f90ab5d0b05fa)(origin);
        const targetHasVar = (0, $021b423722640b5d$export$df8f90ab5d0b05fa)(target);
        if (originHasVar !== targetHasVar && (0, $c8fa35933e0c86f5$export$781d46a8aa670d52)[name]) {
            this.needsMeasurement = true;
            return;
        }
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $c8fa35933e0c86f5$export$8e5250d1aa9bf370)(originType) && (0, $c8fa35933e0c86f5$export$8e5250d1aa9bf370)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else if ((0, $c8fa35933e0c86f5$export$781d46a8aa670d52)[name]) /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null || (0, $02b151aea0fdaf6c$export$e56af863d5645d5f)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $242d3088abfa675c$export$8cc4958f8e540f37)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element || !element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $c8fa35933e0c86f5$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element || !element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $c8fa35933e0c86f5$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if (this.removedTransforms?.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}







const { schedule: $c9047a3b74657671$export$bb76eed83315504c, cancel: $c9047a3b74657671$export$3252729004b8456e } = /* @__PURE__ */ (0, $f47fcc496681f604$export$510b0596a933801a)(queueMicrotask, false);



const $3924f51055f9d169$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $3924f51055f9d169$export$3d227df54007d73a = ()=>({
        x: $3924f51055f9d169$export$ff25708b37f72782(),
        y: $3924f51055f9d169$export$ff25708b37f72782()
    });
const $3924f51055f9d169$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $3924f51055f9d169$export$6459fc9e86be362e = ()=>({
        x: $3924f51055f9d169$export$6db76765312617ac(),
        y: $3924f51055f9d169$export$6db76765312617ac()
    });









/**
 * A list of all ValueTypes
 */ const $c88bd5dd490f7d49$var$valueTypes = [
    ...(0, $ef4dc8f9eec60b86$export$d176691c1998a1f5),
    (0, $1f6a47b5445f6d2e$export$35e9368ef982300f),
    (0, $143d250b15433a18$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $c88bd5dd490f7d49$export$950e7e59ea1ffed7 = (v)=>$c88bd5dd490f7d49$var$valueTypes.find((0, $55427f8648eeb04f$export$6eae4d0a6a7ca7cd)(v));




function $cb890c42b23a56a5$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}


/**
 * Decides if the supplied variable is variant label
 */ function $588b2e1ac067f90b$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


const $c821b4ee572b6f77$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $c821b4ee572b6f77$export$1405a65085f40b9 = [
    "initial",
    ...$c821b4ee572b6f77$export$16e45afcc206d3a8
];


function $ae01bc9957935968$export$4b3c3bd8d910d78d(props) {
    return (0, $cb890c42b23a56a5$export$aa71198ceeaf53ce)(props.animate) || (0, $c821b4ee572b6f77$export$1405a65085f40b9).some((name)=>(0, $588b2e1ac067f90b$export$720b90e312cea233)(props[name]));
}
function $ae01bc9957935968$export$ce46fa4165cdec40(props) {
    return Boolean($ae01bc9957935968$export$4b3c3bd8d910d78d(props) || props.variants);
}





/**
 * Updates motion values from props changes.
 * Uses `any` type for element to avoid circular dependencies with VisualElement.
 */ function $fc4ae96e171d0e6c$export$9a552858d5197f6e(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $332ca6f8f18741ec$export$605d60a2578142d3)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $332ca6f8f18741ec$export$605d60a2578142d3)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $a82ff1c7e83e3798$export$ce8bdc721e76545f)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $a82ff1c7e83e3798$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}


// Does this device prefer reduced motion? Returns `null` server-side.
const $7bc53e620b75ab87$export$ff7706047246b98b = {
    current: null
};
const $7bc53e620b75ab87$export$6476d16e2fd2d0db = {
    current: false
};


const $7864a384f9ce45b8$var$isBrowser = typeof window !== "undefined";
function $7864a384f9ce45b8$export$ca9f41fb23dded3d() {
    (0, $7bc53e620b75ab87$export$6476d16e2fd2d0db).current = true;
    if (!$7864a384f9ce45b8$var$isBrowser) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $7bc53e620b75ab87$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addEventListener("change", setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $7bc53e620b75ab87$export$ff7706047246b98b).current = false;
}





const $b63c2fcec7c42fc8$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * Static feature definitions - can be injected by framework layer
 */ let $b63c2fcec7c42fc8$var$featureDefinitions = {};
/**
 * Set feature definitions for all VisualElements.
 * This should be called by the framework layer (e.g., framer-motion) during initialization.
 */ function $b63c2fcec7c42fc8$export$8ad214844176d967(definitions) {
    $b63c2fcec7c42fc8$var$featureDefinitions = definitions;
}
/**
 * Get the current feature definitions
 */ function $b63c2fcec7c42fc8$export$e183cb9c018608ba() {
    return $b63c2fcec7c42fc8$var$featureDefinitions;
}
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $b63c2fcec7c42fc8$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, skipAnimations: skipAnimations, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * Decides whether animations should be skipped for this VisualElement.
         * Useful for E2E tests and visual regression testing.
         */ this.shouldSkipAnimations = false;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $01b8590b0c4ca61c$export$74d34ca3182f1750);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * Track whether this element has been mounted before, to detect
         * remounts after Suspense unmount/remount cycles.
         */ this.hasBeenMounted = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.renderScheduledAt = 0.0;
        this.scheduleRender = ()=>{
            const now = (0, $ecd2e69909b240c8$export$2da9be4cfdb689b1).now();
            if (this.renderScheduledAt < now) {
                this.renderScheduledAt = now;
                (0, $efc9740269028631$export$2cef06c20297c17d).render(this.render, false, true);
            }
        };
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.skipAnimationsConfig = skipAnimations;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $ae01bc9957935968$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $ae01bc9957935968$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $332ca6f8f18741ec$export$605d60a2578142d3)(value)) value.set(latestValues[key]);
        }
    }
    mount(instance) {
        /**
         * If this element has been mounted before (e.g. after a Suspense
         * unmount/remount), reset motion values to their initial state
         * so animations replay correctly from initial → animate.
         */ if (this.hasBeenMounted) for(const key in this.initialValues){
            this.values.get(key)?.jump(this.initialValues[key]);
            this.latestValues[key] = this.initialValues[key];
        }
        this.current = instance;
        (0, $e8291a1f6a2194c5$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        /**
         * Determine reduced motion preference. Only initialize the matchMedia
         * listener if we actually need the dynamic value (i.e., when config
         * is neither "never" nor "always").
         */ if (this.reducedMotionConfig === "never") this.shouldReduceMotion = false;
        else if (this.reducedMotionConfig === "always") this.shouldReduceMotion = true;
        else {
            if (!(0, $7bc53e620b75ab87$export$6476d16e2fd2d0db).current) (0, $7864a384f9ce45b8$export$ca9f41fb23dded3d)();
            this.shouldReduceMotion = (0, $7bc53e620b75ab87$export$ff7706047246b98b).current;
        }
        /**
         * Set whether animations should be skipped based on the config.
         */ this.shouldSkipAnimations = this.skipAnimationsConfig ?? false;
        this.parent?.addChild(this);
        this.update(this.props, this.presenceContext);
        this.hasBeenMounted = true;
    }
    unmount() {
        this.projection && this.projection.unmount();
        (0, $efc9740269028631$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $efc9740269028631$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent?.removeChild(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    addChild(child) {
        this.children.add(child);
        this.enteringChildren ?? (this.enteringChildren = new Set());
        this.enteringChildren.add(child);
    }
    removeChild(child) {
        this.children.delete(child);
        this.enteringChildren && this.enteringChildren.delete(child);
    }
    bindToMotionValue(key, value) {
        if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
        if (value.accelerate && (0, $901b1d16861d60af$export$a27eefbd8fb5e404).has(key) && this.current instanceof HTMLElement) {
            const { factory: factory, keyframes: keyframes, times: times, ease: ease, duration: duration } = value.accelerate;
            const animation = new (0, $a881d2fd31b5c0fd$export$6c0f9803d8aa7219)({
                element: this.current,
                name: key,
                keyframes: keyframes,
                times: times,
                ease: ease,
                duration: (0, $c8fe15c475fa19ba$export$fc3e7e8557f8c8c7)(duration)
            });
            const cleanup = factory(animation);
            this.valueSubscriptions.set(key, ()=>{
                cleanup();
                animation.cancel();
            });
            return;
        }
        const valueIsTransform = (0, $f2aa2df0b1d5a3cf$export$7b42a0094fb00b6e).has(key);
        if (valueIsTransform && this.onBindTransform) this.onBindTransform();
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $efc9740269028631$export$2cef06c20297c17d).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
            this.scheduleRender();
        });
        let removeSyncCheck;
        if (typeof window !== "undefined" && window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            if (removeSyncCheck) removeSyncCheck();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in $b63c2fcec7c42fc8$var$featureDefinitions){
            const featureDefinition = $b63c2fcec7c42fc8$var$featureDefinitions[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $3924f51055f9d169$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $b63c2fcec7c42fc8$var$propEventHandlers.length; i++){
            const key = $b63c2fcec7c42fc8$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $fc4ae96e171d0e6c$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps || {}, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $a82ff1c7e83e3798$export$ce8bdc721e76545f)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : this.getBaseTargetFromProps(this.props, key) ?? this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $5dc4007ec56ff86d$export$65583ed5a868f2d9)(value) || (0, $4efb885de8ac2039$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $c88bd5dd490f7d49$export$950e7e59ea1ffed7)(value) && (0, $143d250b15433a18$export$83a0e34f1302825b).test(target)) value = (0, $f90b116ea26db880$export$cea0cedcb94873b5)(key, target);
            this.setBaseTarget(key, (0, $332ca6f8f18741ec$export$605d60a2578142d3)(value) ? value.get() : value);
        }
        return (0, $332ca6f8f18741ec$export$605d60a2578142d3)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        const { initial: initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $3fcb84f0549ccfed$export$d68f140c4d9b48bc)(this.props, initial, this.presenceContext?.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $332ca6f8f18741ec$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $559fb93c0e5925ed$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
    scheduleRenderMicrotask() {
        (0, $c9047a3b74657671$export$bb76eed83315504c).render(this.render);
    }
}


class $cfd32ef7b89f33a2$export$e49735c2a366bdc7 extends (0, $b63c2fcec7c42fc8$export$fa8b653c0f3714e5) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $4a3a585a2298ee2a$export$4983792d11b61017);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        const style = props.style;
        return style ? style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $332ca6f8f18741ec$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
}


/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $e9ac55e4b1be5238$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};








const $687b81970545ca52$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $687b81970545ca52$var$numTransforms = (0, $f2aa2df0b1d5a3cf$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $687b81970545ca52$export$bdc96e0d5c8f914(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $687b81970545ca52$var$numTransforms; i++){
        const key = (0, $f2aa2df0b1d5a3cf$export$280dc01950909d86)[i];
        const value = latestValues[key];
        if (value === undefined) continue;
        let valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else {
            const parsed = parseFloat(value);
            valueIsDefault = key.startsWith("scale") ? parsed === 1 : parsed === 0;
        }
        if (!valueIsDefault || transformTemplate) {
            const valueAsType = (0, $e9ac55e4b1be5238$export$453ef540a9a1bd6b)(value, (0, $d5720b77a1a581e4$export$eec14432cd1cb67b)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                const transformName = $687b81970545ca52$var$translateAlias[key] || key;
                transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}


function $729664c5b90341aa$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    const { style: style, vars: vars, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        if ((0, $f2aa2df0b1d5a3cf$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, $021b423722640b5d$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            const valueAsType = (0, $e9ac55e4b1be5238$export$453ef540a9a1bd6b)(value, (0, $d5720b77a1a581e4$export$eec14432cd1cb67b)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $687b81970545ca52$export$bdc96e0d5c8f914)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}


function $d9a6298b0e200dd6$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    const elementStyle = element.style;
    let key;
    for(key in style)// CSSStyleDeclaration has [index: number]: string; in the types, so we use that as key type.
    elementStyle[key] = style[key];
    // Write projection styles directly to element style
    projection?.applyProjectionStyles(elementStyle, styleProp);
    for(key in vars)// Loop over any CSS variables and assign those.
    // They can only be assigned using `setProperty`.
    elementStyle.setProperty(key, vars[key]);
}






function $6a3b3623727c38e6$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $6a3b3623727c38e6$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $31304987b0919f83$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $6a3b3623727c38e6$export$fafff692be55225d(latest, node.target.x);
        const y = $6a3b3623727c38e6$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $25a48ed78a3a2d2a$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $143d250b15433a18$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $143d250b15433a18$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $bb85245f2bb1740c$export$3bb0b4ff1037b8dd)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};


const $51364cbceb6ed6be$export$91ddd985b97788d1 = {
    borderRadius: {
        ...(0, $6a3b3623727c38e6$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $6a3b3623727c38e6$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $6a3b3623727c38e6$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $6a3b3623727c38e6$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $6a3b3623727c38e6$export$5eafb6257a5844c),
    boxShadow: (0, $25a48ed78a3a2d2a$export$eb0bc629e74dcf8)
};
function $51364cbceb6ed6be$export$de9e7791c71225fd(correctors) {
    for(const key in correctors){
        $51364cbceb6ed6be$export$91ddd985b97788d1[key] = correctors[key];
        if ((0, $021b423722640b5d$export$9de1236619d9e756)(key)) $51364cbceb6ed6be$export$91ddd985b97788d1[key].isCSSVariable = true;
    }
}


function $e0d7c253a3ff65f1$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $f2aa2df0b1d5a3cf$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $51364cbceb6ed6be$export$91ddd985b97788d1)[key] || key === "opacity");
}


function $389a45bdc11788ec$export$16da615486abaa45(props, prevProps, visualElement) {
    const style = props.style;
    const prevStyle = prevProps?.style;
    const newValues = {};
    if (!style) return newValues;
    for(const key in style)if ((0, $332ca6f8f18741ec$export$605d60a2578142d3)(style[key]) || prevStyle && (0, $332ca6f8f18741ec$export$605d60a2578142d3)(prevStyle[key]) || (0, $e0d7c253a3ff65f1$export$6d27ce8e3de1c3cf)(key, props) || visualElement?.getValue(key)?.liveStyle !== undefined) newValues[key] = style[key];
    return newValues;
}


function $9eb803f281f7ce1f$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $9eb803f281f7ce1f$export$23fea75b03ac16b3 extends (0, $cfd32ef7b89f33a2$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "html";
        this.renderInstance = (0, $d9a6298b0e200dd6$export$1a32bf6229c258c0);
    }
    readValueFromInstance(instance, key) {
        if ((0, $f2aa2df0b1d5a3cf$export$7b42a0094fb00b6e).has(key)) return this.projection?.isProjecting ? (0, $90e46a0bb3605a3d$export$1f10c01143b9f089)(key) : (0, $90e46a0bb3605a3d$export$bcd97e0e03ba17f6)(instance, key);
        else {
            const computedStyle = $9eb803f281f7ce1f$export$3735103072e4a80(instance);
            const value = ((0, $021b423722640b5d$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $583c68faadf0bf08$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, $729664c5b90341aa$export$bb517f8b40f8e99d)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $389a45bdc11788ec$export$16da615486abaa45)(props, prevProps, visualElement);
    }
}

function $856440401627445a$export$a6cdc56e425d0d0a(value) {
    return typeof value === "object" && value !== null;
}


/**
 * Checks if an element is an SVG element in a way
 * that works across iframes
 */ function $619238d96e131844$export$17eda790a720ec57(element) {
    return (0, $856440401627445a$export$a6cdc56e425d0d0a)(element) && "ownerSVGElement" in element;
}


/**
 * Checks if an element is specifically an SVGSVGElement (the root SVG element)
 * in a way that works across iframes
 */ function $eb168268bbaaee3e$export$66957ea77182581d(element) {
    return (0, $619238d96e131844$export$17eda790a720ec57)(element) && element.tagName === "svg";
}



function $68fdc88c32863428$var$isObjectKey(key, object) {
    return key in object;
}
class $68fdc88c32863428$export$fe67a5eca4e986d6 extends (0, $b63c2fcec7c42fc8$export$fa8b653c0f3714e5) {
    constructor(){
        super(...arguments);
        this.type = "object";
    }
    readValueFromInstance(instance, key) {
        if ($68fdc88c32863428$var$isObjectKey(key, instance)) {
            const value = instance[key];
            if (typeof value === "string" || typeof value === "number") return value;
        }
        return undefined;
    }
    getBaseTargetFromProps() {
        return undefined;
    }
    removeValueFromRenderState(key, renderState) {
        delete renderState.output[key];
    }
    measureInstanceViewportBox() {
        return (0, $3924f51055f9d169$export$6459fc9e86be362e)();
    }
    build(renderState, latestValues) {
        Object.assign(renderState.output, latestValues);
    }
    renderInstance(instance, { output: output }) {
        Object.assign(instance, output);
    }
    sortInstanceNodePosition() {
        return 0;
    }
}







const $1e3d54485e36ddcb$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $1e3d54485e36ddcb$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 *
 * Note: We use unitless values for stroke-dasharray and stroke-dashoffset
 * because Safari incorrectly scales px values when the page is zoomed.
 */ function $1e3d54485e36ddcb$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $1e3d54485e36ddcb$var$dashKeys : $1e3d54485e36ddcb$var$camelKeys;
    // Build the dash offset (unitless to avoid Safari zoom bug)
    attrs[keys.offset] = `${-offset}`;
    // Build the dash array (unitless to avoid Safari zoom bug)
    attrs[keys.array] = `${length} ${spacing}`;
}


/**
 * CSS Motion Path properties that should remain as CSS styles on SVG elements.
 */ const $a08870718540c00b$var$cssMotionPathProperties = [
    "offsetDistance",
    "offsetPath",
    "offsetRotate",
    "offsetAnchor"
];
/**
 * Build SVG visual attributes, like cx and style.transform
 */ function $a08870718540c00b$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, isSVGTag, transformTemplate, styleProp) {
    (0, $729664c5b90341aa$export$bb517f8b40f8e99d)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style } = state;
    /**
     * However, we apply transforms as CSS transforms.
     * So if we detect a transform, transformOrigin we take it from attrs and copy it into style.
     */ if (attrs.transform) {
        style.transform = attrs.transform;
        delete attrs.transform;
    }
    if (style.transform || attrs.transformOrigin) {
        style.transformOrigin = attrs.transformOrigin ?? "50% 50%";
        delete attrs.transformOrigin;
    }
    if (style.transform) {
        /**
         * SVG's element transform-origin uses its own median as a reference.
         * Therefore, transformBox becomes a fill-box
         */ style.transformBox = styleProp?.transformBox ?? "fill-box";
        delete attrs.transformBox;
    }
    for (const key of $a08870718540c00b$var$cssMotionPathProperties)if (attrs[key] !== undefined) {
        style[key] = attrs[key];
        delete attrs[key];
    }
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $1e3d54485e36ddcb$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $fd4c4fae5ac9d079$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


const $d1e0a16f53b6c9e7$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";





function $ab2215b56740deab$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $d9a6298b0e200dd6$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $fd4c4fae5ac9d079$export$28931db5d57958e5).has(key) ? (0, $d3d0fe356277c935$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $a8a4f1f7085848d7$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $389a45bdc11788ec$export$16da615486abaa45)(props, prevProps, visualElement);
    for(const key in props)if ((0, $332ca6f8f18741ec$export$605d60a2578142d3)(props[key]) || (0, $332ca6f8f18741ec$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $f2aa2df0b1d5a3cf$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}


class $14e2f281277626a0$export$86bcdffbaf733d84 extends (0, $cfd32ef7b89f33a2$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = (0, $3924f51055f9d169$export$6459fc9e86be362e);
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $f2aa2df0b1d5a3cf$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $095fe303cfb39d3a$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $fd4c4fae5ac9d079$export$28931db5d57958e5).has(key) ? (0, $d3d0fe356277c935$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $a8a4f1f7085848d7$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        (0, $a08870718540c00b$export$5475d24f125d7053)(renderState, latestValues, this.isSVGTag, props.transformTemplate, props.style);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $ab2215b56740deab$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $d1e0a16f53b6c9e7$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}


function $e17644b207db2d22$export$602bd1946a6d1d47(element) {
    const options = {
        presenceContext: null,
        props: {},
        visualState: {
            renderState: {
                transform: {},
                transformOrigin: {},
                style: {},
                vars: {},
                attrs: {}
            },
            latestValues: {}
        }
    };
    const node = (0, $619238d96e131844$export$17eda790a720ec57)(element) && !(0, $eb168268bbaaee3e$export$66957ea77182581d)(element) ? new (0, $14e2f281277626a0$export$86bcdffbaf733d84)(options) : new (0, $9eb803f281f7ce1f$export$23fea75b03ac16b3)(options);
    node.mount(element);
    (0, $e8291a1f6a2194c5$export$bc2a978a17abfdde).set(element, node);
}
function $e17644b207db2d22$export$69c3b8be1812d4ee(subject) {
    const options = {
        presenceContext: null,
        props: {},
        visualState: {
            renderState: {
                output: {}
            },
            latestValues: {}
        }
    };
    const node = new (0, $68fdc88c32863428$export$fe67a5eca4e986d6)(options);
    node.mount(subject);
    (0, $e8291a1f6a2194c5$export$bc2a978a17abfdde).set(subject, node);
}




function $3bac2e85f6e0b2b9$var$isSingleValue(subject, keyframes) {
    return (0, $332ca6f8f18741ec$export$605d60a2578142d3)(subject) || typeof subject === "number" || typeof subject === "string" && !(0, $90f32defc8ee2bd1$export$d276bfce3b1077ca)(keyframes);
}
/**
 * Implementation
 */ function $3bac2e85f6e0b2b9$export$7f91f5969506fd92(subject, keyframes, options, scope) {
    const animations = [];
    if ($3bac2e85f6e0b2b9$var$isSingleValue(subject, keyframes)) animations.push((0, $1cbdbcafdf460253$export$335a17c977067b99)(subject, (0, $90f32defc8ee2bd1$export$d276bfce3b1077ca)(keyframes) ? keyframes.default || keyframes : keyframes, options ? options.default || options : options));
    else {
        // Gracefully handle null/undefined subjects (e.g., from querySelector returning null)
        if (subject == null) return animations;
        const subjects = (0, $4dc00288ce198975$export$92b2aefc56600400)(subject, keyframes, scope);
        const numSubjects = subjects.length;
        (0, $1f68be864a33a611$export$f5708dca728d7177)(Boolean(numSubjects), "No valid elements provided.", "no-valid-elements");
        for(let i = 0; i < numSubjects; i++){
            const thisSubject = subjects[i];
            const createVisualElement = thisSubject instanceof Element ? (0, $e17644b207db2d22$export$602bd1946a6d1d47) : (0, $e17644b207db2d22$export$69c3b8be1812d4ee);
            if (!(0, $e8291a1f6a2194c5$export$bc2a978a17abfdde).has(thisSubject)) createVisualElement(thisSubject);
            const visualElement = (0, $e8291a1f6a2194c5$export$bc2a978a17abfdde).get(thisSubject);
            const transition = {
                ...options
            };
            /**
             * Resolve stagger function if provided.
             */ if ("delay" in transition && typeof transition.delay === "function") transition.delay = transition.delay(i, numSubjects);
            animations.push(...(0, $41f382a3711b7d58$export$68cacfeee78d98d2)(visualElement, {
                ...keyframes,
                transition: transition
            }, {}));
        }
    }
    return animations;
}


function $643b9880f895537a$export$82a013c5b12ef57f(sequence, options, scope) {
    const animations = [];
    /**
     * Pre-process: replace function segments with MotionValue segments,
     * subscribe callbacks immediately
     */ const processedSequence = sequence.map((segment)=>{
        if (Array.isArray(segment) && typeof segment[0] === "function") {
            const callback = segment[0];
            const mv = (0, $a82ff1c7e83e3798$export$ce8bdc721e76545f)(0);
            mv.on("change", callback);
            if (segment.length === 1) return [
                mv,
                [
                    0,
                    1
                ]
            ];
            else if (segment.length === 2) return [
                mv,
                [
                    0,
                    1
                ],
                segment[1]
            ];
            else return [
                mv,
                segment[1],
                segment[2]
            ];
        }
        return segment;
    });
    const animationDefinitions = (0, $eec42b624b7aefb8$export$1f0f44b51a4b2f73)(processedSequence, options, scope, {
        spring: $cb6a5de6c9fd4114$export$b36281d89752ae66
    });
    animationDefinitions.forEach(({ keyframes: keyframes, transition: transition }, subject)=>{
        animations.push(...(0, $3bac2e85f6e0b2b9$export$7f91f5969506fd92)(subject, keyframes, transition));
    });
    return animations;
}



function $127e7dcc461f45a6$var$isSequence(value) {
    return Array.isArray(value) && value.some(Array.isArray);
}
/**
 * Creates an animation function that is optionally scoped
 * to a specific element.
 */ function $127e7dcc461f45a6$export$c17e592002be9b90(options = {}) {
    const { scope: scope, reduceMotion: reduceMotion } = options;
    /**
     * Implementation
     */ function scopedAnimate(subjectOrSequence, optionsOrKeyframes, options) {
        let animations = [];
        let animationOnComplete;
        if ($127e7dcc461f45a6$var$isSequence(subjectOrSequence)) {
            const { onComplete: onComplete, ...sequenceOptions } = optionsOrKeyframes || {};
            if (typeof onComplete === "function") animationOnComplete = onComplete;
            animations = (0, $643b9880f895537a$export$82a013c5b12ef57f)(subjectOrSequence, reduceMotion !== undefined ? {
                reduceMotion: reduceMotion,
                ...sequenceOptions
            } : sequenceOptions, scope);
        } else {
            // Extract top-level onComplete so it doesn't get applied per-value
            const { onComplete: onComplete, ...rest } = options || {};
            if (typeof onComplete === "function") animationOnComplete = onComplete;
            animations = (0, $3bac2e85f6e0b2b9$export$7f91f5969506fd92)(subjectOrSequence, optionsOrKeyframes, reduceMotion !== undefined ? {
                reduceMotion: reduceMotion,
                ...rest
            } : rest, scope);
        }
        const animation = new (0, $ae2001463fda0404$export$77cf9b7b4d0397cf)(animations);
        if (animationOnComplete) animation.finished.then(animationOnComplete);
        if (scope) {
            scope.animations.push(animation);
            animation.finished.then(()=>{
                (0, $8e6f83cd8e8d205a$export$fe2d9b4e03920b4c)(scope.animations, animation);
            });
        }
        return animation;
    }
    return scopedAnimate;
}
const $127e7dcc461f45a6$export$e3607ec2d7a891c4 = $127e7dcc461f45a6$export$c17e592002be9b90();


/**
 * Smooth expand / collapse for WordPress Accordion blocks (core/accordion).
 *
 * How it works:
 *   - CSS overrides the accordion-item to flex-column (kills grid row
 *     interference) and zeroes vertical panel padding (replaced by
 *     ::before / ::after pseudo-elements so height:0 = true zero).
 *   - JS animates only height + opacity on the panel.
 *   - A MutationObserver on each item's `class` attribute detects the
 *     `is-open` toggle fired by WordPress Interactivity API.
 *
 * Timing (per animation-design guidelines):
 *   - Expand  250 ms  ease-out-quart  (element entering → ease-out)
 *   - Collapse 200 ms  ease-out-quart  (exit → 20 % faster than enter)
 *   - Opacity fades in with a slight delay so content appears *as* the
 *     drawer opens. On collapse, opacity dissolves first, then height.
 */ const $092c41516b241bdf$var$EASE_OUT_QUART = [
    0.165,
    0.84,
    0.44,
    1
];
const $092c41516b241bdf$var$EXPAND_DURATION = 0.25;
const $092c41516b241bdf$var$COLLAPSE_DURATION = 0.2;
const $092c41516b241bdf$export$5b6f5cde8f19041b = ({ motionEnabled: motionEnabled })=>{
    if (!motionEnabled) return;
    const items = document.querySelectorAll(".wp-block-accordion-item");
    if (!items.length) return;
    items.forEach($092c41516b241bdf$var$setupItem);
};
/* ── Per-item setup ───────────────────────────────────────────────────────── */ function $092c41516b241bdf$var$setupItem(item) {
    const panel = item.querySelector(".wp-block-accordion-panel");
    if (!panel) return;
    let running = null; // array of Motion controls for the active animation
    // Apply initial visual state
    if (item.classList.contains("is-open")) $092c41516b241bdf$var$setExpanded(panel);
    else $092c41516b241bdf$var$setCollapsed(panel);
    // Watch for the is-open class toggle (fired by WP Interactivity API)
    const observer = new MutationObserver(()=>{
        const opening = item.classList.contains("is-open");
        // Cancel in-flight animation — Motion leaves styles at their current
        // interpolated value, so the next animation starts seamlessly.
        if (running) {
            running.forEach((ctrl)=>ctrl.cancel());
            running = null;
        }
        running = opening ? $092c41516b241bdf$var$expand(panel) : $092c41516b241bdf$var$collapse(panel);
    });
    observer.observe(item, {
        attributes: true,
        attributeFilter: [
            "class"
        ]
    });
}
/* ── State helpers ────────────────────────────────────────────────────────── */ function $092c41516b241bdf$var$setCollapsed(panel) {
    panel.style.height = "0";
    panel.style.overflow = "hidden";
    panel.style.opacity = "0";
}
function $092c41516b241bdf$var$setExpanded(panel) {
    panel.style.height = "auto";
    panel.style.overflow = "visible";
    panel.style.opacity = "1";
}
/* ── Expand ───────────────────────────────────────────────────────────────── */ function $092c41516b241bdf$var$expand(panel) {
    panel.style.overflow = "hidden";
    // Snapshot current state (handles mid-collapse interruption)
    const currentHeight = parseFloat(getComputedStyle(panel).height) || 0;
    const currentOpacity = parseFloat(getComputedStyle(panel).opacity) || 0;
    // Temporarily expand to measure the exact rendered height
    panel.style.height = "auto";
    const targetHeight = panel.getBoundingClientRect().height;
    // Snap back so the animation starts from the current value
    panel.style.height = `${currentHeight}px`;
    panel.offsetHeight; // force reflow
    const heightCtrl = (0, $127e7dcc461f45a6$export$e3607ec2d7a891c4)(panel, {
        height: [
            `${currentHeight}px`,
            `${targetHeight}px`
        ]
    }, {
        duration: $092c41516b241bdf$var$EXPAND_DURATION,
        easing: $092c41516b241bdf$var$EASE_OUT_QUART
    });
    // Opacity fades in slightly after height starts — content appears as
    // the drawer opens rather than being visible at 1 px of height.
    const opacityDelay = currentOpacity > 0 ? 0 : $092c41516b241bdf$var$EXPAND_DURATION * 0.2;
    const opacityCtrl = (0, $127e7dcc461f45a6$export$e3607ec2d7a891c4)(panel, {
        opacity: [
            currentOpacity,
            1
        ]
    }, {
        duration: $092c41516b241bdf$var$EXPAND_DURATION * 0.8,
        delay: opacityDelay,
        easing: $092c41516b241bdf$var$EASE_OUT_QUART
    });
    Promise.all([
        heightCtrl.finished,
        opacityCtrl.finished
    ]).then(()=>{
        $092c41516b241bdf$var$setExpanded(panel);
    });
    return [
        heightCtrl,
        opacityCtrl
    ];
}
/* ── Collapse ─────────────────────────────────────────────────────────────── */ function $092c41516b241bdf$var$collapse(panel) {
    const startHeight = panel.getBoundingClientRect().height;
    const currentOpacity = parseFloat(getComputedStyle(panel).opacity) || 1;
    panel.style.height = `${startHeight}px`;
    panel.style.overflow = "hidden";
    panel.offsetHeight; // force reflow
    // Opacity dissolves first — content fades before the drawer closes.
    const opacityCtrl = (0, $127e7dcc461f45a6$export$e3607ec2d7a891c4)(panel, {
        opacity: [
            currentOpacity,
            0
        ]
    }, {
        duration: $092c41516b241bdf$var$COLLAPSE_DURATION * 0.5,
        easing: $092c41516b241bdf$var$EASE_OUT_QUART
    });
    const heightCtrl = (0, $127e7dcc461f45a6$export$e3607ec2d7a891c4)(panel, {
        height: [
            `${startHeight}px`,
            "0px"
        ]
    }, {
        duration: $092c41516b241bdf$var$COLLAPSE_DURATION,
        easing: $092c41516b241bdf$var$EASE_OUT_QUART
    });
    Promise.all([
        heightCtrl.finished,
        opacityCtrl.finished
    ]).then(()=>{
        $092c41516b241bdf$var$setCollapsed(panel);
    });
    return [
        heightCtrl,
        opacityCtrl
    ];
}


const $9b6ed258ad32c751$export$a53fbda95265b5ef = ()=>{
    const svgNamespace = "http://www.w3.org/2000/svg";
    const cardIcons = document.querySelectorAll(".himml-frontpage-cards-2 .wp-block-outermost-icon-block svg");
    cardIcons.forEach((svg, index)=>{
        if (!(svg instanceof SVGSVGElement)) return;
        const gradientId = `himml-frontpage-cards-2-gradient-${index}`;
        let defs = svg.querySelector("defs");
        if (!defs) {
            defs = document.createElementNS(svgNamespace, "defs");
            svg.prepend(defs);
        }
        let gradient = defs.querySelector(`#${gradientId}`);
        if (!gradient) {
            gradient = document.createElementNS(svgNamespace, "linearGradient");
            gradient.setAttribute("id", gradientId);
            gradient.setAttribute("x1", "0%");
            gradient.setAttribute("y1", "0%");
            gradient.setAttribute("x2", "100%");
            gradient.setAttribute("y2", "100%");
            const start = document.createElementNS(svgNamespace, "stop");
            start.setAttribute("offset", "0%");
            start.setAttribute("stop-color", "#0e4194");
            const end = document.createElementNS(svgNamespace, "stop");
            end.setAttribute("offset", "100%");
            end.setAttribute("stop-color", "#60a5fa");
            gradient.append(start, end);
            defs.appendChild(gradient);
        }
        svg.querySelectorAll("path").forEach((path)=>{
            path.setAttribute("fill", `url(#${gradientId})`);
        });
    });
};


const $7aff72326f3926ce$var$addHeroClass = (element, className)=>{
    if (element) element.classList.add(className);
};
const $7aff72326f3926ce$export$cc8c3d5bb57be015 = ({ motionEnabled: motionEnabled })=>{
    if (!motionEnabled) return;
    const heroes = Array.from(document.querySelectorAll(".himml-hero, .himml-hero-2"));
    if (heroes.length === 0) return;
    heroes.forEach((hero)=>{
        const heroContent = hero.querySelector(".wp-block-media-text__content");
        const heroPill = hero.querySelector(".himml-notice");
        const heroHeadline = heroContent?.querySelector("h1.wp-block-heading, h1, .wp-block-heading");
        const heroVisual = hero.querySelector(".wp-block-media-text__media");
        let heroSubheadline = null;
        let heroCtas = null;
        let heroSocialProof = null;
        if (heroContent) {
            const ctaButton = heroContent.querySelector(".wp-block-buttons");
            if (ctaButton) heroCtas = ctaButton.closest(".wp-block-group");
            const ratingStars = heroContent.querySelector(".himml26-rating-stars");
            if (ratingStars) heroSocialProof = ratingStars.closest(".wp-block-group");
            const headingGroup = heroHeadline?.closest(".wp-block-group");
            if (headingGroup) heroSubheadline = headingGroup.querySelector("p");
            if (!heroSubheadline) heroSubheadline = heroContent.querySelector("p");
        }
        $7aff72326f3926ce$var$addHeroClass(heroPill, "hero-pill");
        $7aff72326f3926ce$var$addHeroClass(heroHeadline, "hero-headline");
        $7aff72326f3926ce$var$addHeroClass(heroSubheadline, "hero-subheadline");
        $7aff72326f3926ce$var$addHeroClass(heroVisual, "hero-visual");
        $7aff72326f3926ce$var$addHeroClass(heroCtas, "hero-ctas");
        $7aff72326f3926ce$var$addHeroClass(heroSocialProof, "hero-social-proof");
        hero.classList.add("hero-animate");
    });
};



const $d438281f06ad051e$var$thresholds = {
    some: 0,
    all: 1
};
function $d438281f06ad051e$export$acb1e9cb9ce4ca56(elementOrSelector, onStart, { root: root, margin: rootMargin, amount: amount = "some" } = {}) {
    const elements = (0, $04a3ae0e7d2ff9fd$export$90ceba2564a894f8)(elementOrSelector);
    const activeIntersections = new WeakMap();
    const onIntersectionChange = (entries)=>{
        entries.forEach((entry)=>{
            const onEnd = activeIntersections.get(entry.target);
            /**
             * If there's no change to the intersection, we don't need to
             * do anything here.
             */ if (entry.isIntersecting === Boolean(onEnd)) return;
            if (entry.isIntersecting) {
                const newOnEnd = onStart(entry.target, entry);
                if (typeof newOnEnd === "function") activeIntersections.set(entry.target, newOnEnd);
                else observer.unobserve(entry.target);
            } else if (typeof onEnd === "function") {
                onEnd(entry);
                activeIntersections.delete(entry.target);
            }
        });
    };
    const observer = new IntersectionObserver(onIntersectionChange, {
        root: root,
        rootMargin: rootMargin,
        threshold: typeof amount === "number" ? amount : $d438281f06ad051e$var$thresholds[amount]
    });
    elements.forEach((element)=>observer.observe(element));
    return ()=>observer.disconnect();
}


function $8b40014eceef61ff$export$35c8f6884e82cf8d(from, total) {
    if (from === "first") return 0;
    else {
        const lastIndex = total - 1;
        return from === "last" ? lastIndex : lastIndex / 2;
    }
}
function $8b40014eceef61ff$export$ef0b4d89074db4d0(duration = 0.1, { startDelay: startDelay = 0, from: from = 0, ease: ease } = {}) {
    return (i, total)=>{
        const fromIndex = typeof from === "number" ? from : $8b40014eceef61ff$export$35c8f6884e82cf8d(from, total);
        const distance = Math.abs(fromIndex - i);
        let delay = duration * distance;
        if (ease) {
            const maxDelay = total * duration;
            const easingFunction = (0, $ba45346e85a9f5d6$export$ef97fe084f156ca4)(ease);
            delay = easingFunction(delay / maxDelay) * maxDelay;
        }
        return startDelay + delay;
    };
}


/**
 * Unified scroll-triggered entrance animations for all card layouts.
 * Uses Motion v12 (WAAPI) — replaces the old IntersectionObserver + CSS
 * keyframe systems with a single, consistent approach.
 *
 * Supported selectors:
 *   .is-style-himml-1          (block style)
 *   .is-style-himml-cards      (block style, alias for legacy .himml-cards)
 *   .himml-cards                (legacy manual class)
 *   .himml-frontpage-cards      (legacy manual class)
 *   .himml-card-columns         (legacy manual class)
 *   .is-style-frontpage-cards   (block style)
 *   .himml-frontpage-cards-2    (legacy manual class)
 *   .is-style-frontpage-cards-2 (block style)
 */ const $d028ec4aa125a357$var$isSingleColumn = (cards)=>{
    if (cards.length < 2) return true;
    const firstLeft = cards[0].getBoundingClientRect().left;
    return cards.every((card)=>Math.abs(card.getBoundingClientRect().left - firstLeft) < 8);
};
/**
 * Animate a set of cards within a section container.
 */ const $d028ec4aa125a357$var$animateSection = (section, cards)=>{
    if (!cards.length) return;
    // Guard against replays: Motion's `inView` fires its callback every time the
    // section re-enters the viewport — and load-time layout shifts near the hero
    // can trigger enter → leave → enter within the same page load. Because the
    // keyframes reset opacity to 0, each fire replayed the entrance (the "animated
    // twice" bug). Run the entrance exactly once, then stop observing.
    let hasAnimated = false;
    let stop;
    stop = (0, $d438281f06ad051e$export$acb1e9cb9ce4ca56)(section, ()=>{
        if (hasAnimated) return;
        hasAnimated = true;
        if (typeof stop === "function") stop();
        const singleCol = $d028ec4aa125a357$var$isSingleColumn(cards);
        (0, $127e7dcc461f45a6$export$e3607ec2d7a891c4)(cards, {
            opacity: [
                0,
                1
            ],
            y: [
                28,
                0
            ],
            filter: [
                "blur(2px)",
                "blur(0px)"
            ]
        }, {
            duration: 0.6,
            delay: (0, $8b40014eceef61ff$export$ef0b4d89074db4d0)(singleCol ? 0 : 0.12),
            easing: [
                0.22,
                1,
                0.36,
                1
            ]
        }).finished.then(()=>{
            cards.forEach((card)=>{
                card.style.removeProperty("opacity");
                card.style.removeProperty("transform");
                card.style.removeProperty("filter");
                card.classList.add("motion-entered");
            });
        });
    }, {
        amount: 0.12
    });
};
/**
 * Selectors grouped by animation target.
 * Each section's direct .wp-block-column children are animated.
 */ const $d028ec4aa125a357$var$CARD_SECTION_SELECTORS = [
    ".wp-block-columns.is-style-himml-1",
    ".wp-block-columns.is-style-himml-cards",
    ".wp-block-columns.himml-cards",
    ".wp-block-columns.himml-frontpage-cards",
    ".wp-block-columns.himml-card-columns",
    ".wp-block-columns.is-style-frontpage-cards",
    ".wp-block-columns.himml-frontpage-cards-2",
    ".wp-block-columns.is-style-frontpage-cards-2"
].join(",\n");
const $d028ec4aa125a357$export$69b9e61c8c8a243f = ({ motionEnabled: motionEnabled })=>{
    if (!motionEnabled) return;
    const sections = document.querySelectorAll($d028ec4aa125a357$var$CARD_SECTION_SELECTORS);
    sections.forEach((section)=>{
        const cards = [
            ...section.querySelectorAll(":scope > .wp-block-column")
        ];
        $d028ec4aa125a357$var$animateSection(section, cards);
    });
};


// Keep WordPress in charge of the modal and desktop dropdowns. The mobile
// view reads the same editor-owned links, but shows one navigation level at
// a time; it never writes to core's submenu state or aria-expanded bindings.
// Horizontal touch gestures belong to the menu; vertical scrolling and pinch
// zoom remain native. The left screen edge stays available for the OS gesture.
const $94160489232ea3ce$export$802490c37ba0db0f = (viewport, menu, getTrail, goBack)=>{
    let gesture = null;
    let suppressClickUntil = 0;
    const reset = ()=>{
        if (!gesture) return;
        const previousGesture = gesture;
        gesture = null;
        if (viewport.hasPointerCapture(previousGesture.id)) viewport.releasePointerCapture(previousGesture.id);
        previousGesture.previous.element.removeAttribute("data-swipe-back");
        menu.removeAttribute("data-swiping");
        menu.style.removeProperty("--himml-menu-swipe-x");
    };
    viewport.addEventListener("pointerdown", (event)=>{
        reset();
        suppressClickUntil = 0;
        const trail = getTrail();
        if (!event.isPrimary || event.pointerType === "mouse" || trail.length < 2 || event.clientX < 24) return;
        gesture = {
            id: event.pointerId,
            x: event.clientX,
            y: event.clientY,
            started: event.timeStamp,
            dragging: false,
            current: trail[trail.length - 1],
            previous: trail[trail.length - 2]
        };
    }, {
        passive: true
    });
    viewport.addEventListener("pointermove", (event)=>{
        if (!gesture || event.pointerId !== gesture.id) return;
        const dx = event.clientX - gesture.x;
        const dy = Math.abs(event.clientY - gesture.y);
        if (!gesture.dragging) {
            if (dy > 10 && dy > Math.abs(dx) || dx < -10) {
                reset();
                return;
            }
            if (dx < 10 || dx < dy * 1.25) return;
            gesture.dragging = true;
            viewport.setPointerCapture(event.pointerId);
            gesture.previous.element.setAttribute("data-swipe-back", "");
            menu.dataset.swiping = "true";
        }
        if (event.cancelable) event.preventDefault();
        menu.style.setProperty("--himml-menu-swipe-x", `${Math.max(0, Math.min(dx, viewport.clientWidth))}px`);
    });
    viewport.addEventListener("pointerup", (event)=>{
        if (!gesture || event.pointerId !== gesture.id) return;
        const dx = event.clientX - gesture.x;
        const dy = Math.abs(event.clientY - gesture.y);
        const elapsed = Math.max(1, event.timeStamp - gesture.started);
        const distance = Math.min(100, Math.max(56, viewport.clientWidth * 0.2));
        const commit = gesture.dragging && dx > dy * 1.25 && (dx >= distance || dx >= 32 && dx / elapsed > 0.5) && getTrail().at(-1) === gesture.current;
        if (gesture.dragging) {
            suppressClickUntil = performance.now() + 400;
            menu.dataset.animate = "true";
        }
        reset();
        if (commit) goBack(true);
    });
    viewport.addEventListener("pointercancel", reset);
    viewport.addEventListener("lostpointercapture", (event)=>{
        // Moving implicit capture from a touched link to the viewport also emits
        // this event on the link. Only losing our own capture cancels the swipe.
        if (event.target === viewport) reset();
    });
    // A swipe that starts over a link must not activate that link on release.
    viewport.addEventListener("click", (event)=>{
        if (event.detail > 0 && performance.now() < suppressClickUntil) {
            event.preventDefault();
            event.stopPropagation();
        }
    }, true);
};


const $0d30f9fdf53a413a$var$MENU_CLASS = "himml-mobile-menu";
const $0d30f9fdf53a413a$var$READY_CLASS = "himml-mobile-drilldown";
const $0d30f9fdf53a413a$var$ITEM_LINK = ":scope > .wp-block-navigation-item__content";
const $0d30f9fdf53a413a$var$SUBMENU = ":scope > .wp-block-navigation__submenu-container";
// A second tap this soon and this close to the one that opened a level is
// the rest of a double tap, not a choice in the new level.
const $0d30f9fdf53a413a$var$DOUBLE_TAP_MS = 500;
const $0d30f9fdf53a413a$var$DOUBLE_TAP_RADIUS = 40;
const $0d30f9fdf53a413a$var$labelOf = (element)=>element.textContent.replace(/\s+/g, " ").trim();
const $0d30f9fdf53a413a$var$copyLinkAttributes = (source, link)=>{
    [
        "href",
        "target",
        "rel",
        "hreflang",
        "download",
        "aria-current",
        "aria-label"
    ].forEach((attribute)=>{
        if (source?.hasAttribute(attribute)) link.setAttribute(attribute, source.getAttribute(attribute));
        else link.removeAttribute(attribute);
    });
};
const $0d30f9fdf53a413a$var$createLink = (source, className)=>{
    const link = document.createElement("a");
    $0d30f9fdf53a413a$var$copyLinkAttributes(source, link);
    link.className = className;
    link.textContent = $0d30f9fdf53a413a$var$labelOf(source);
    return link;
};
const $0d30f9fdf53a413a$var$createMenu = (container)=>{
    const content = container.querySelector(".wp-block-navigation__responsive-container-content");
    const sourceList = content?.querySelector(":scope > .wp-block-navigation__container");
    const navigation = container.closest("nav");
    const openButton = navigation?.querySelector(".wp-block-navigation__responsive-container-open");
    const closeButton = container.querySelector(".wp-block-navigation__responsive-container-close");
    if (!sourceList || !openButton || !closeButton || container.classList.contains($0d30f9fdf53a413a$var$READY_CLASS)) return;
    const menu = document.createElement("div");
    menu.className = $0d30f9fdf53a413a$var$MENU_CLASS;
    const brand = document.createElement("div");
    brand.className = `${$0d30f9fdf53a413a$var$MENU_CLASS}__brand`;
    const sourceLogo = (navigation.closest("header") || document).querySelector(".wp-block-site-logo");
    let logoLink = null;
    if (sourceLogo) {
        const logo = sourceLogo.cloneNode(true);
        logo.className = `${$0d30f9fdf53a413a$var$MENU_CLASS}__logo`;
        [
            logo,
            ...logo.querySelectorAll("*")
        ].forEach((element)=>{
            element.removeAttribute("id");
            [
                ...element.attributes
            ].forEach(({ name: name })=>{
                if (name.startsWith("data-wp-")) element.removeAttribute(name);
            });
        });
        logoLink = logo.querySelector("a[href]");
        brand.append(logo);
    }
    const syncChrome = ()=>{
        const buttonRect = openButton.getBoundingClientRect();
        const logoRect = sourceLogo?.querySelector("img")?.getBoundingClientRect();
        if (!buttonRect.width || !logoRect?.width) return;
        const headerRect = navigation.closest("#site-header")?.getBoundingClientRect();
        const values = {
            "logo-x": logoRect.left,
            "logo-y": logoRect.top,
            "logo-width": logoRect.width,
            "close-y": buttonRect.top,
            "close-width": buttonRect.width,
            "close-height": buttonRect.height,
            "close-right": document.documentElement.clientWidth - buttonRect.right,
            "brand-height": headerRect?.bottom || Math.max(logoRect.bottom, buttonRect.bottom) + 12
        };
        Object.entries(values).forEach(([name, value])=>{
            container.style.setProperty(`--himml-menu-${name}`, `${value}px`);
        });
    };
    openButton.addEventListener("click", syncChrome, true);
    const path = document.createElement("div");
    path.className = `${$0d30f9fdf53a413a$var$MENU_CLASS}__path`;
    const back = document.createElement("button");
    back.type = "button";
    back.className = `${$0d30f9fdf53a413a$var$MENU_CLASS}__back`;
    back.textContent = "Zur\xfcck";
    const title = document.createElement("h2");
    title.className = `${$0d30f9fdf53a413a$var$MENU_CLASS}__title`;
    title.tabIndex = -1;
    const titleLink = document.createElement("a");
    title.append(titleLink);
    path.append(back, title);
    const viewport = document.createElement("div");
    viewport.className = `${$0d30f9fdf53a413a$var$MENU_CLASS}__viewport`;
    const panels = [];
    let trail = [];
    let levelTap = null;
    const render = ({ animate: animate = false, focus: focus = null } = {})=>{
        const current = trail[trail.length - 1];
        menu.dataset.animate = String(animate);
        menu.dataset.depth = String(trail.length - 1);
        back.setAttribute("aria-label", trail.length > 2 ? `Zur\xfcck zu ${trail[trail.length - 2].label}` : "Zur\xfcck zum Hauptmen\xfc");
        titleLink.textContent = current.label;
        // Make the destination focusable before hiding the previous level.
        current.element.inert = false;
        current.element.removeAttribute("aria-hidden");
        current.element.dataset.position = "current";
        focus?.focus({
            preventScroll: true
        });
        // Keep the link node stable and hand off focus before removing its href
        // when returning to the main menu, including Escape from the title link.
        $0d30f9fdf53a413a$var$copyLinkAttributes(current.parentLink, titleLink);
        // Hide Back only after handing off focus. Hiding the focused button first
        // fires focusout with relatedTarget=null, which WordPress treats as an
        // instruction to close the entire navigation overlay.
        back.hidden = trail.length === 1;
        panels.forEach((panel)=>{
            const active = panel === current;
            panel.element.dataset.position = active ? "current" : trail.includes(panel) ? "before" : "after";
            panel.element.inert = !active;
            if (!active) panel.element.setAttribute("aria-hidden", "true");
            panel.trigger?.setAttribute("aria-expanded", String(trail.includes(panel)));
        });
    };
    const buildPanel = (list, label, parentLink = null, trigger = null)=>{
        const element = document.createElement("div");
        element.className = `${$0d30f9fdf53a413a$var$MENU_CLASS}__panel`;
        element.id = `${container.id}-level-${panels.length}`;
        element.dataset.position = "after";
        element.inert = true;
        element.setAttribute("aria-hidden", "true");
        element.setAttribute("role", "group");
        element.setAttribute("aria-label", label);
        const panel = {
            element: element,
            label: label,
            trigger: trigger,
            parentLink: parentLink
        };
        panels.push(panel);
        viewport.append(element);
        if (parentLink?.hasAttribute("href")) {
            const overview = $0d30f9fdf53a413a$var$createLink(parentLink, `${$0d30f9fdf53a413a$var$MENU_CLASS}__overview`);
            overview.textContent = "Zur \xdcbersicht";
            overview.setAttribute("aria-label", `${label}: Zur \xdcbersicht`);
            element.append(overview);
        }
        const items = document.createElement("ul");
        items.className = `${$0d30f9fdf53a413a$var$MENU_CLASS}__list`;
        element.append(items);
        [
            ...list.children
        ].forEach((item)=>{
            const source = item.querySelector($0d30f9fdf53a413a$var$ITEM_LINK);
            if (!source) return;
            const row = document.createElement("li");
            const submenu = item.querySelector($0d30f9fdf53a413a$var$SUBMENU);
            if (submenu) {
                const button = document.createElement("button");
                button.type = "button";
                button.className = `${$0d30f9fdf53a413a$var$MENU_CLASS}__item ${$0d30f9fdf53a413a$var$MENU_CLASS}__next`;
                button.textContent = $0d30f9fdf53a413a$var$labelOf(source);
                button.setAttribute("aria-label", `${$0d30f9fdf53a413a$var$labelOf(source)}: Untermen\xfc \xf6ffnen`);
                const child = buildPanel(submenu, $0d30f9fdf53a413a$var$labelOf(source), source, button);
                button.setAttribute("aria-controls", child.element.id);
                button.setAttribute("aria-expanded", "false");
                // Show the way to the current page while it is still levels away.
                if (source.hasAttribute("aria-current") || submenu.querySelector("[aria-current]")) button.dataset.currentBranch = "";
                button.addEventListener("click", (event)=>{
                    levelTap = event.detail > 0 ? {
                        panel: child,
                        x: event.clientX,
                        y: event.clientY,
                        time: event.timeStamp
                    } : null;
                    trail.push(child);
                    child.element.scrollTop = 0;
                    render({
                        animate: event.detail > 0,
                        focus: title
                    });
                });
                row.append(button);
            } else if (source.hasAttribute("href")) row.append($0d30f9fdf53a413a$var$createLink(source, `${$0d30f9fdf53a413a$var$MENU_CLASS}__item`));
            if (row.childElementCount) items.append(row);
        });
        return panel;
    };
    const root = buildPanel(sourceList, "Men\xfc");
    trail = [
        root
    ];
    const goBack = (animate)=>{
        if (trail.length < 2) return;
        const previous = trail.pop();
        render({
            animate: animate,
            focus: previous.trigger
        });
    };
    back.addEventListener("click", (event)=>goBack(event.detail > 0));
    (0, $94160489232ea3ce$export$802490c37ba0db0f)(viewport, menu, ()=>trail, goBack);
    // The second tap of a double tap lands on whatever slid in under the finger,
    // often "Zur Übersicht", and would leave the page. Keyboard activation has
    // detail 0 and is never held back.
    viewport.addEventListener("click", (event)=>{
        if (event.detail > 0 && levelTap?.panel === trail[trail.length - 1] && event.timeStamp - levelTap.time < $0d30f9fdf53a413a$var$DOUBLE_TAP_MS && Math.hypot(event.clientX - levelTap.x, event.clientY - levelTap.y) < $0d30f9fdf53a413a$var$DOUBLE_TAP_RADIUS) {
            event.preventDefault();
            event.stopPropagation();
        }
    }, true);
    const dock = document.createElement("div");
    dock.className = `${$0d30f9fdf53a413a$var$MENU_CLASS}__dock`;
    const phoneSource = content.querySelector('a[href^="tel:"]');
    if (phoneSource) {
        const availability = document.createElement("p");
        availability.textContent = "Tag und Nacht f\xfcr Sie erreichbar";
        dock.append(availability, $0d30f9fdf53a413a$var$createLink(phoneSource, `${$0d30f9fdf53a413a$var$MENU_CLASS}__phone`));
    }
    const contactSource = [
        ...sourceList.querySelectorAll(":scope > li > a[href]")
    ].find((link)=>new URL(link.href).pathname.replace(/\/$/, "") === "/kontakt");
    if (contactSource) dock.append($0d30f9fdf53a413a$var$createLink(contactSource, `${$0d30f9fdf53a413a$var$MENU_CLASS}__contact`));
    menu.append(brand, path, viewport, dock);
    content.append(menu);
    container.classList.add($0d30f9fdf53a413a$var$READY_CLASS);
    render();
    const isOpen = ()=>container.classList.contains("has-modal-open");
    let wasOpen = isOpen();
    // Core focuses the first focusable element one frame after opening, which
    // is the cloned logo link. Hand that first focus on to the first menu entry
    // so keyboard and screen reader users start in the menu, not on "home".
    let redirectOpeningFocus = false;
    container.addEventListener("focusin", (event)=>{
        if (!redirectOpeningFocus) return;
        redirectOpeningFocus = false;
        if (event.target !== logoLink) return;
        trail[trail.length - 1].element.querySelector("a[href], button")?.focus({
            preventScroll: true
        });
    });
    new MutationObserver(()=>{
        const open = isOpen();
        if (open !== wasOpen) {
            wasOpen = open;
            redirectOpeningFocus = open && Boolean(logoLink);
            // Reset on opening: clearing the title link while closing can remove
            // its href before the browser follows the link that was just clicked.
            if (!open) return;
            syncChrome();
            trail = [
                root
            ];
            panels.forEach(({ element: element })=>{
                element.scrollTop = 0;
            });
            render();
        }
    }).observe(container, {
        attributes: true,
        attributeFilter: [
            "class"
        ]
    });
    container.addEventListener("keydown", (event)=>{
        if (!isOpen()) return;
        if (event.key === "Escape" && trail.length > 1) {
            event.preventDefault();
            event.stopPropagation();
            goBack(false);
            return;
        }
        if (event.key !== "Tab") return;
        // Core caches its focus boundaries when opening. Navigation levels change
        // afterwards, so calculate the visible targets for every Tab instead.
        const focusable = [
            ...container.querySelectorAll("a[href], button:not([disabled])")
        ].filter((element)=>!element.closest("[inert]") && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== "hidden");
        if (!focusable.length) return;
        const index = focusable.indexOf(document.activeElement);
        const afterTitle = focusable.findIndex((element)=>title.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_FOLLOWING);
        const next = index < 0 ? document.activeElement === title && afterTitle >= 0 ? (afterTitle - (event.shiftKey ? 1 : 0) + focusable.length) % focusable.length : event.shiftKey ? focusable.length - 1 : 0 : (index + (event.shiftKey ? -1 : 1) + focusable.length) % focusable.length;
        event.preventDefault();
        event.stopPropagation();
        focusable[next].focus();
    }, true);
    menu.addEventListener("click", (event)=>{
        if (event.target instanceof Element && event.target.closest("a[href]")) closeButton.click();
    });
    window.addEventListener("resize", ()=>{
        // Respect the actual editor/plugin breakpoint, including tablet layouts.
        if (isOpen()) {
            if (openButton.getClientRects().length === 0) closeButton.click();
            else syncChrome();
        }
    }, {
        passive: true
    });
};
const $0d30f9fdf53a413a$export$70f8385659b6152c = ()=>{
    document.querySelectorAll(".wp-block-navigation__responsive-container").forEach($0d30f9fdf53a413a$var$createMenu);
};


// Enhance the normal FSE header without duplicating its logo or controls.
const $5475b01957d07890$export$231ce57e9b8bd237 = ()=>{
    const header = document.querySelector("#site-header.himml-header");
    const shell = header?.closest("header");
    if (!header || !shell) return;
    const mobile = window.matchMedia("(max-width: 1199px)");
    const adminBar = document.getElementById("wpadminbar");
    const adminRows = adminBar ? [
        adminBar,
        ...adminBar.querySelectorAll(".ab-top-menu")
    ] : [];
    const menu = header.querySelector(".wp-block-navigation__responsive-container");
    let previousY = window.scrollY;
    let distance = 0;
    let frame = 0;
    let height = header.offsetHeight;
    shell.classList.add("himml-header-shell");
    const measure = ()=>{
        height = header.offsetHeight;
        shell.style.setProperty("--himml-header-height", `${height}px`);
    };
    const show = ()=>header.classList.remove("is-hidden");
    const update = ()=>{
        frame = 0;
        // Clamp elastic overscroll so iOS rubber-banding does not reverse direction.
        const maxY = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        const y = Math.max(0, Math.min(window.scrollY, maxY));
        const delta = y - previousY;
        previousY = y;
        const adminOffset = Math.max(0, ...adminRows.map((row)=>row.getBoundingClientRect().bottom));
        header.style.setProperty("--himml-header-admin-offset", `${adminOffset}px`);
        if (!mobile.matches || y <= height || menu?.classList.contains("has-modal-open")) {
            distance = 0;
            show();
            return;
        }
        if (!delta) return;
        distance = Math.sign(delta) === Math.sign(distance) ? distance + delta : delta;
        // Small direction changes should not make the header flicker.
        if (Math.abs(distance) < 12) return;
        const keyboardFocus = header.querySelector(":focus-visible");
        header.classList.toggle("is-hidden", distance > 0 && !keyboardFocus);
        distance = 0;
    };
    const queueUpdate = ()=>{
        if (!frame) frame = requestAnimationFrame(update);
    };
    const resize = ()=>{
        header.classList.toggle("himml-scroll-header", mobile.matches);
        measure();
        distance = 0;
        update();
    };
    new ResizeObserver(measure).observe(header);
    if (menu) new MutationObserver(queueUpdate).observe(menu, {
        attributes: true,
        attributeFilter: [
            "class"
        ]
    });
    header.addEventListener("focusin", show);
    mobile.addEventListener("change", resize);
    window.addEventListener("scroll", queueUpdate, {
        passive: true
    });
    window.addEventListener("resize", resize, {
        passive: true
    });
    window.addEventListener("pageshow", resize);
    resize();
    requestAnimationFrame(()=>header.classList.add("is-scroll-ready"));
};



var $6VdLB = parcelRequire("6VdLB");
const $bc6d032acd6e7632$var$initThemeInteractions = ()=>{
    const motionEnabled = (0, $6VdLB.getMotionEnabled)();
    (0, $5475b01957d07890$export$231ce57e9b8bd237)();
    (0, $0d30f9fdf53a413a$export$70f8385659b6152c)();
    (0, $9b6ed258ad32c751$export$a53fbda95265b5ef)();
    (0, $7aff72326f3926ce$export$cc8c3d5bb57be015)({
        motionEnabled: motionEnabled
    });
    (0, $d028ec4aa125a357$export$69b9e61c8c8a243f)({
        motionEnabled: motionEnabled
    });
    (0, $092c41516b241bdf$export$5b6f5cde8f19041b)({
        motionEnabled: motionEnabled
    });
};
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $bc6d032acd6e7632$var$initThemeInteractions);
else $bc6d032acd6e7632$var$initThemeInteractions();


document.addEventListener("DOMContentLoaded", function() {
    const calmButtonSelector = ".wp-block-button.is-style-animated-border .wp-block-button__link";
    function shouldReduceMotion() {
        if (typeof window.matchMedia !== "function") return false;
        return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }
    function parseRgbColor(value) {
        const channels = String(value || "").match(/[\d.]+/g);
        if (!channels || channels.length < 3) return null;
        return {
            r: Number(channels[0]),
            g: Number(channels[1]),
            b: Number(channels[2]),
            a: channels.length >= 4 ? Number(channels[3]) : 1
        };
    }
    function colorWithAlpha(value, alpha) {
        const color = parseRgbColor(value);
        if (!color) return value;
        return `rgba(${color.r}, ${color.g}, ${color.b}, ${Math.min(color.a, alpha)})`;
    }
    function getRelativeLuminance(value) {
        const color = parseRgbColor(value);
        if (!color) return 0;
        const channels = [
            color.r,
            color.g,
            color.b
        ].map(function(channel) {
            const normalized = channel / 255;
            return normalized <= 0.03928 ? normalized / 12.92 : ((normalized + 0.055) / 1.055) ** 2.4;
        });
        return channels[0] * 0.2126 + channels[1] * 0.7152 + channels[2] * 0.0722;
    }
    function isTransparentColor(value) {
        const color = parseRgbColor(value);
        return !color || color.a <= 0;
    }
    function setCalmProperty(button, property, value) {
        if (button.style.getPropertyValue(property) === value) return;
        button.style.setProperty(property, value);
    }
    function setCalmBoxShadow(button, value) {
        if (button.calmCurrentGlowStack === value) return;
        button.calmCurrentGlowStack = value;
        button.style.boxShadow = value;
    }
    function syncCalmButtonTokens(button) {
        const styles = getComputedStyle(button);
        const backgroundColor = styles.backgroundColor;
        const textColor = styles.color;
        const backgroundLuminance = getRelativeLuminance(backgroundColor);
        const hasVisibleBackground = !isTransparentColor(backgroundColor) && backgroundLuminance <= 0.86;
        const hasDarkBackground = hasVisibleBackground && backgroundLuminance < 0.28;
        const glowColor = hasVisibleBackground ? backgroundColor : textColor;
        const borderColor = textColor;
        const edgeAlpha = hasDarkBackground ? 0.3 : 0.24;
        const edgeHoverAlpha = hasDarkBackground ? 0.44 : 0.34;
        const glowAlpha = hasDarkBackground ? 0.28 : 0.2;
        const glowHoverAlpha = hasDarkBackground ? 0.38 : 0.28;
        const edgeGlowColor = colorWithAlpha(borderColor, edgeAlpha);
        const edgeGlowHoverColor = colorWithAlpha(borderColor, edgeHoverAlpha);
        const ambientGlowColor = colorWithAlpha(glowColor, glowAlpha);
        const ambientGlowHoverColor = colorWithAlpha(glowColor, glowHoverAlpha);
        const glowStack = [
            `0 0 0 1px ${edgeGlowColor}`,
            `0 0 8px ${edgeGlowColor}`,
            `0 0 18px 2px ${ambientGlowColor}`
        ].join(", ");
        const glowStackHover = [
            `0 0 0 1px ${edgeGlowHoverColor}`,
            `0 0 10px 1px ${edgeGlowHoverColor}`,
            `0 0 24px 3px ${ambientGlowHoverColor}`
        ].join(", ");
        setCalmProperty(button, "--calm-accent", borderColor);
        setCalmProperty(button, "--calm-accent-soft", colorWithAlpha(borderColor, 0.5));
        setCalmProperty(button, "--calm-edge-glow-color", edgeGlowColor);
        setCalmProperty(button, "--calm-edge-glow-hover-color", edgeGlowHoverColor);
        setCalmProperty(button, "--calm-ripple", colorWithAlpha(borderColor, 0.2));
        setCalmProperty(button, "--calm-glow-color", ambientGlowColor);
        setCalmProperty(button, "--calm-glow-hover-color", ambientGlowHoverColor);
        setCalmProperty(button, "--calm-glow-stack", glowStack);
        setCalmProperty(button, "--calm-glow-stack-hover", glowStackHover);
        setCalmBoxShadow(button, button.matches(":hover") || button === document.activeElement ? glowStackHover : glowStack);
    }
    function observeCalmButtonTokenChanges(button) {
        if (button.calmTokenObserver) return;
        const wrapper = button.closest(".wp-block-button");
        const observer = new MutationObserver(function() {
            syncCalmButtonTokens(button);
        });
        const options = {
            attributes: true,
            attributeFilter: [
                "class",
                "style"
            ]
        };
        observer.observe(button, options);
        if (wrapper) observer.observe(wrapper, options);
        button.calmTokenObserver = observer;
    }
    function handleCalmButtonKeyActivation(event) {
        const button = event.currentTarget;
        const isAnchorEnter = button instanceof HTMLAnchorElement && event.key === "Enter";
        if (isAnchorEnter || event.key !== "Enter" && event.key !== " ") return;
        event.preventDefault();
        button.click();
    }
    function createCalmRipple(button, event) {
        if (shouldReduceMotion()) return;
        const ripple = document.createElement("span");
        ripple.classList.add("ripple");
        const rect = button.getBoundingClientRect();
        const size = Math.max(rect.width, rect.height);
        const isPointerClick = event instanceof MouseEvent && event.detail > 0;
        const x = isPointerClick ? event.clientX - rect.left - size / 2 : rect.width / 2 - size / 2;
        const y = isPointerClick ? event.clientY - rect.top - size / 2 : rect.height / 2 - size / 2;
        ripple.style.width = `${size}px`;
        ripple.style.height = `${size}px`;
        ripple.style.left = `${x}px`;
        ripple.style.top = `${y}px`;
        const rippleColor = getComputedStyle(button).getPropertyValue("--calm-ripple").trim() || "rgba(14, 65, 148, 0.18)";
        ripple.style.background = rippleColor;
        button.appendChild(ripple);
        ripple.animate([
            {
                transform: "scale(0)",
                opacity: 0.55
            },
            {
                transform: "scale(1.35)",
                opacity: 0
            }
        ], {
            duration: 420,
            easing: "cubic-bezier(0.23, 1, 0.32, 1)"
        }).onfinish = function() {
            ripple.remove();
        };
    }
    function initCalmButtons(root = document) {
        if (!(root instanceof Element) && root !== document) return;
        const buttons = root.matches?.(calmButtonSelector) ? [
            root
        ] : Array.from(root.querySelectorAll(calmButtonSelector));
        buttons.forEach(function(button) {
            if (button.dataset.calmInit === "true") return;
            button.dataset.calmInit = "true";
            syncCalmButtonTokens(button);
            observeCalmButtonTokenChanges(button);
            [
                "mouseenter",
                "focus"
            ].forEach(function(eventName) {
                button.addEventListener(eventName, function() {
                    syncCalmButtonTokens(button);
                });
            });
            [
                "mouseleave",
                "blur"
            ].forEach(function(eventName) {
                button.addEventListener(eventName, function() {
                    syncCalmButtonTokens(button);
                });
            });
            button.addEventListener("click", function(event) {
                syncCalmButtonTokens(button);
                createCalmRipple(button, event);
            });
            button.addEventListener("keydown", handleCalmButtonKeyActivation);
            if (!button.getAttribute("aria-label")) button.setAttribute("aria-label", button.textContent.trim());
        });
    }
    initCalmButtons();
    const jumpLinkSelector = ".vimeo-jump-link";
    const jumpListSelector = ".custom-spalte-vorsorgeberater-fragestellungen ol";
    const vimeoIframeSelector = 'iframe.lw-video-section__video[src*="player.vimeo.com"], iframe[src*="player.vimeo.com/video/"]';
    const playerScriptSrc = "https://player.vimeo.com/api/player.js";
    const playerStates = new WeakMap();
    let activeIframe = null;
    let pendingJump = null;
    let playerApiPromise = null;
    function hasVimeoApi() {
        return typeof window.Vimeo !== "undefined" && typeof window.Vimeo.Player === "function";
    }
    function isVisible(element) {
        if (!element) return false;
        const rect = element.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0;
    }
    function getVimeoIframes(scope = document) {
        return Array.from(scope.querySelectorAll(vimeoIframeSelector));
    }
    function syncJumpListCounter(list) {
        if (!(list instanceof HTMLOListElement)) return;
        const start = parseInt(list.getAttribute("start"), 10);
        const counterStart = Number.isNaN(start) ? 0 : start - 1;
        list.style.setProperty("--himml-list-start", String(counterStart));
    }
    function syncJumpListCounters(scope = document) {
        if (scope instanceof HTMLOListElement && scope.matches(jumpListSelector)) {
            syncJumpListCounter(scope);
            return;
        }
        if (!(scope instanceof Element) && scope !== document) return;
        scope.querySelectorAll(jumpListSelector).forEach(syncJumpListCounter);
    }
    function setActiveIframe(iframe) {
        if (iframe?.matches(vimeoIframeSelector)) activeIframe = iframe;
    }
    function getPlayerState(iframe) {
        let state = playerStates.get(iframe);
        if (!state) {
            state = {
                playerPromise: null
            };
            playerStates.set(iframe, state);
        }
        return state;
    }
    function watchIframe(iframe) {
        if (!iframe || iframe.dataset.vimeoJumpBound === "true") return;
        iframe.dataset.vimeoJumpBound = "true";
        [
            "pointerdown",
            "mouseenter",
            "focus"
        ].forEach(function(eventName) {
            iframe.addEventListener(eventName, function() {
                setActiveIframe(iframe);
            });
        });
        iframe.addEventListener("load", function() {
            setActiveIframe(iframe);
            ensurePlayer(iframe);
            flushPendingJump();
        });
        ensurePlayer(iframe);
    }
    function watchKnownIframes(scope = document) {
        getVimeoIframes(scope).forEach(watchIframe);
    }
    function getScopedIframes(link) {
        const scope = link?.closest("article, .entry-content, main, body") || document;
        return getVimeoIframes(scope);
    }
    function getIframeForLink(link) {
        const scopedIframes = getScopedIframes(link);
        if (!scopedIframes.length || !link) return null;
        const linkTop = link.getBoundingClientRect().top;
        const rankedIframes = scopedIframes.map(function(iframe) {
            return {
                iframe: iframe,
                top: iframe.getBoundingClientRect().top
            };
        }).sort(function(a, b) {
            return b.top - a.top;
        });
        const precedingVisibleMatch = rankedIframes.find(function(entry) {
            return entry.top <= linkTop + 24 && isVisible(entry.iframe);
        });
        if (precedingVisibleMatch) return precedingVisibleMatch.iframe;
        const precedingMatch = rankedIframes.find(function(entry) {
            return entry.top <= linkTop + 24;
        });
        if (precedingMatch) return precedingMatch.iframe;
        return scopedIframes.find(isVisible) || scopedIframes[0] || null;
    }
    function getActiveIframe(link) {
        const relatedIframe = getIframeForLink(link);
        if (relatedIframe) {
            setActiveIframe(relatedIframe);
            return relatedIframe;
        }
        if (activeIframe && document.contains(activeIframe)) return activeIframe;
        const fallbackIframe = getVimeoIframes().find(isVisible) || getVimeoIframes()[0];
        if (fallbackIframe) setActiveIframe(fallbackIframe);
        return fallbackIframe || null;
    }
    function loadVimeoPlayerApi() {
        if (hasVimeoApi()) return Promise.resolve(window.Vimeo);
        if (playerApiPromise) return playerApiPromise;
        playerApiPromise = new Promise(function(resolve, reject) {
            let script = document.querySelector('script[data-vimeo-player-api="true"]');
            if (!script) {
                script = document.createElement("script");
                script.src = playerScriptSrc;
                script.async = true;
                script.dataset.vimeoPlayerApi = "true";
                document.head.appendChild(script);
            }
            script.addEventListener("load", function handleLoad() {
                if (hasVimeoApi()) {
                    resolve(window.Vimeo);
                    return;
                }
                playerApiPromise = null;
                reject(new Error("Vimeo player API loaded without window.Vimeo"));
            });
            script.addEventListener("error", function handleError() {
                playerApiPromise = null;
                reject(new Error("Failed to load Vimeo player API"));
            });
        });
        return playerApiPromise;
    }
    function ensurePlayer(iframe) {
        watchIframe(iframe);
        const state = getPlayerState(iframe);
        if (state.playerPromise) return state.playerPromise;
        state.playerPromise = loadVimeoPlayerApi().then(function() {
            const player = new window.Vimeo.Player(iframe);
            return player.ready().then(function() {
                return player;
            });
        }).catch(function(error) {
            state.playerPromise = null;
            throw error;
        });
        return state.playerPromise;
    }
    function getJumpLinkFromEvent(event) {
        if (event.target instanceof Element) {
            const directMatch = event.target.closest(jumpLinkSelector);
            if (directMatch) return directMatch;
        }
        if (typeof event.composedPath === "function") {
            const composedMatch = event.composedPath().find(function(node) {
                return node instanceof Element && node.matches(jumpLinkSelector);
            });
            if (composedMatch) return composedMatch;
        }
        return null;
    }
    function seekPlayer(player, seconds) {
        return Promise.race([
            player.setCurrentTime(seconds),
            new Promise(function(resolve) {
                window.setTimeout(function() {
                    resolve(null);
                }, 1500);
            })
        ]).then(function() {
            return player.play().catch(function() {
                return null;
            });
        });
    }
    function performJump(iframe, seconds) {
        setActiveIframe(iframe);
        return ensurePlayer(iframe).then(function(player) {
            return seekPlayer(player, seconds);
        }).catch(function() {
            return false;
        });
    }
    function flushPendingJump() {
        if (!pendingJump) return Promise.resolve(false);
        const nextJump = pendingJump;
        const iframe = getActiveIframe(nextJump.link);
        if (!iframe) return Promise.resolve(false);
        return performJump(iframe, nextJump.seconds).then(function() {
            if (pendingJump === nextJump) pendingJump = null;
            return true;
        });
    }
    document.addEventListener("click", function(event) {
        const link = getJumpLinkFromEvent(event);
        if (!link) return;
        event.preventDefault();
        event.stopPropagation();
        const seconds = parseInt(link.getAttribute("data-time"), 10);
        if (Number.isNaN(seconds)) return;
        const iframe = getActiveIframe(link);
        if (iframe) {
            pendingJump = null;
            performJump(iframe, seconds);
            return;
        }
        pendingJump = {
            link: link,
            seconds: seconds
        };
        flushPendingJump();
    }, true);
    watchKnownIframes();
    syncJumpListCounters();
    if (document.body) {
        const observer = new MutationObserver(function(mutations) {
            let shouldRetryJump = Boolean(pendingJump);
            mutations.forEach(function(mutation) {
                mutation.addedNodes.forEach(function(node) {
                    if (!(node instanceof Element)) return;
                    if (node.matches(vimeoIframeSelector)) {
                        watchIframe(node);
                        shouldRetryJump = true;
                    }
                    syncJumpListCounters(node);
                    initCalmButtons(node);
                    if (node.querySelectorAll) {
                        const nestedIframes = node.querySelectorAll(vimeoIframeSelector);
                        nestedIframes.forEach(function(iframe) {
                            watchIframe(iframe);
                            shouldRetryJump = true;
                        });
                    }
                });
            });
            if (shouldRetryJump) flushPendingJump();
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
});


 // import anime from "./js/vendor/anime.min.js";
 // Make anime available globally if needed
 // window.anime = anime;

})();
//# sourceMappingURL=bundle.js.map
